import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import axios from '../../../utils/axiosExt';
import UserPage1 from './UserPage1';
import { facility_details_for_Facility,facility_details_for_field, hfrVerify, roledetails,userdetails, userdetailsForFacility, userdetailsForField } from '../../../constants';
import UserPage2 from './UserPage2';
import UserPage3 from './UserPage3';
import Loading from "@components/common/Loading";
import './CreateNewUser.css';
import { useDispatch,useSelector } from 'react-redux';
import { resetForm, updateForm } from '../../../store/actions/userManagementAction';
import { RootState } from '../../../store/reducers';
import { getData,getDataParams, getDataWithCache, postDataJSON } from '../../../services/CommonApiService';
import endpoints from '../../../config/endpoints';
import { useNavigate, useParams } from 'react-router-dom';
import RedInfoIcon from '../../../assets/svg/exclamation.svg'
import ButtonModal from '@components/common/Button';
import dayjs from 'dayjs';
import CreateCommonComponent from '@components/common/CreateComponent';
import Auth from "../../../utils/auth";

import { toast } from 'react-toastify';
import { errorLogger, infoLogger } from '@utils/applicationLogUtils';
import {  decodeWithKeyAndShift, encodeWithKeyAndShift } from '../../../utils/base64Utils';
import CommonModal from '../CreateNewUser/AlertModal/index';
import isUsingGramPanchayatUtils from '@utils/isUsingGrampanchayatUtil';
import { userDesignationConstant } from '@constants/appConstants';
import { USER_TYPES } from '@constants/userTypes';
interface newUserProps {
    page?: string;
    flow?: string;
}

interface objectType {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?:any,
  code?:any,
  compositeRoleId?:any,
}

export interface formStateType {
  [key: string]: objectType
}

interface formDataType {
  [key: string]: any;
}

enum LocationType {
  Village = 'village',
  Ward = 'ward',
  GP = 'gp'
}
enum UserDesignation{
  anm='ANM',
}

const CreateNewUser: React.FC<newUserProps> = ({ page }: any) => {
  // const dropdownOptions = ['Option 1', 'Option 2', 'Option 3'];
  //Modal Pages
  const [navItemsModal, setnavItemsModal] = useState(['']);
  const [verifyHfr, setVerifyHfr] = useState<boolean>(false);
  const [verifyAbha, setVerifyAbha] = useState<boolean>(false);
  const [alertModalOpen, setAlertModalOpen] = useState<boolean>(false);
  const [initialFacilityNames, setInitialFacilityNames]=useState<any>({});
  const [intialFacilityTypes, setIntialFacilityTypes]=useState<any>({});
  const [isFacilityLevelUser, setIsFacilityLevelUser]= useState<boolean>(false);
  const [isFieldLevelUser, setIsFieldLevelUser]= useState<boolean>(false);
  const isOkButtonClicked=useSelector((state:RootState)=>state.user.isOkButtonClicked);
  const hprNullCheck=useSelector((state:RootState)=>state.user.hprNullCheck);
  const hprNumberCheck=useSelector((state:RootState)=>state.user.hprNumberCheck);
  const dispatch=useDispatch();
  const { id } = useParams();
  const Files=useSelector((state:RootState)=>state.user.file);
  const ishprEntered=useSelector((state:RootState)=>state.user.ishprEntered);
  const clearHpr=useSelector((state:RootState)=>state.user.clearHpr);
  const isNotVerified=useSelector((state:RootState)=>state.user.isNotVerified);
  const isVerified=useSelector((state:RootState)=>state.user.isVerified);
  const hfrAbhaId=useSelector((state:RootState)=>state.user.hfrAbha);
  const faceAuthVerifiedMob=useSelector((state:RootState)=>state.user.mob);
  const [hasZonesCreated, setHasZonesCreated] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false);  
  const [userTypeName,setUserTypeName] = useState<any>(localStorage.getItem('userTypeName'));
  const [isGrampanchayat, setIsGrampanchayat] = useState<boolean>(false);  
  const isBlockLevelLogin = userTypeName === 'Block Level User';
  // null until the blocks API responds, so we don't fetch villages before we know if blocks exist for this district
  const [hasBlocksForDistrict, setHasBlocksForDistrict] = useState<boolean | null>(null);
  const [facilityLocationId, setFacilityLocationId] = useState<string>('');  
  const [facilityLocationType, setFacilityLocationType] = useState<LocationType>();  
  const [ulbInputText, setUlbInputText] = useState<string>('');
  const consentDetails = useSelector((state:RootState)=>state.user.consentDetails)
  const verificationProcessId = useSelector((state:RootState)=>state.user.verificationProcessId)
  const LoggedInUserId = localStorage.getItem('userId');
  const userDetails = localStorage.getItem('userDetails');
  const loggedInUserDetails=JSON.parse(decodeWithKeyAndShift(userDetails));

  //userPage1
  const [formState1, setFormState1] = useState<formStateType>({
    fName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    lName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    user_type: {
      isError: false,
      message: '',
      id:'',
      code:undefined,
      isDisable: false,
      value: ''
    },
    designation: {
      isError: false,
      message: '',
      id:'',
      code:undefined,
      isDisable: false,
      value: ''
    },
    mob: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    a_mob: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    email: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    doj: {
      isError: false,
      message: '',
      isDisable: false,
      value: null,
    },
    hpr_id:{
      isError: false,
      message: '',
      isDisable: true,
      value: '',
    },
    abha_id:{
      isError: false,
      message: '',
      isDisable: true,
      value: '',
    },
   
    user_status: {
      isError: false,
      message: '',
      isDisable: false,
      value: true,
    }
   
  });  

  const [roleFormState, setRoleFormState] = useState<formStateType>({
    role_name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
      code:undefined,
      compositeRoleId:'',
    },
    state: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
      code:''
    },
    zone_div_circle:{
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
      code:undefined
    },
    district: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
      code:undefined
    },
    sub_district: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
      code:undefined
    },
    sub_division: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
      code:undefined
    },
    health_block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
      code:undefined
    },
    rural_urban: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
      code:undefined
    },
    block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
      code:undefined
    },
    village: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
      code:undefined
    },
    gram_panchayat: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
      code:undefined
    },
    ulb: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
      code:undefined
    },
    ward: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
      code:undefined
    },
   
    reportUserWithLineListingData: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
    offlineModeAccess: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
    mfa: {
      isError: false,
      message: '',
      isDisable: false,
      value: true,
    },
  });

  const checkIfUsingGramPanchayat =async () =>{
    if(roleFormState?.state?.code){
      try {
        let isUsingGramPanchayat: boolean = false;
        isUsingGramPanchayat = await isUsingGramPanchayatUtils(roleFormState?.state?.code);
        setIsGrampanchayat(isUsingGramPanchayat);
        setRoleFormData((role_details:any) => ({
          ...role_details,
          village:{
            ...role_details?.village,
            '#isVisible': isUsingGramPanchayat ? false : true,      
          },
          gram_panchayat:{
            ...role_details?.gram_panchayat,
            '#isVisible': isUsingGramPanchayat ? true : false, 
          }
        }));
        setfacilityFormData((facilityFormData:any)=>({
          ...facilityFormData,
          village:{
            ...facilityFormData.village,
            '#isVisible': isUsingGramPanchayat ? false : true,      
          },
          gram_panchayat:{
            ...facilityFormData.gram_panchayat,
            '#isVisible': isUsingGramPanchayat ? true : false, 
          }
        }));
        setfieldFormData((facilityFormData:any)=>({
          ...facilityFormData,
          village:{
            ...facilityFormData.village,
            '#isVisible': isUsingGramPanchayat ? false : true,      
          },
          gram_panchayat:{
            ...facilityFormData.gram_panchayat,
            '#isVisible': isUsingGramPanchayat ? true : false, 
          }
        }));

      }     catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
     }
    }
  }

  const [userData,setUserData]=useState<any>(userdetails)
  const [ruralUrban,setRuralUrban]=useState<any>('');
  const [ruralUrbanId,setRuralUrbanId]=useState<any>('');
  const [formStateForFacility, setFormStateForFacility] = useState<formStateType>({
    hfr_id: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    health_facility_type: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    health_facility_name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    health_provider_tagged: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:[]
    },
    ward: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id:[],
      code:[]
    },
    village: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id:[],
      code:[]
    },
    gram_panchayat: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id:[],
      code:[]
    },
    mobiliser_tagged: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    volunteerForPmsma: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
  });
  const [formStateForField, setFormStateForField] = useState<formStateType>({
    hfr_id: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    health_facility_type: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    health_facility_name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    health_provider_tagged: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:[],
    },
    mobiliser_tagged: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:''
    },
    ward: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id:[],
      code:[]
    },
    village: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id:[],
      code:[]
    },
    gram_panchayat: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id:[],
      code:[]
    },

  });
  const [roleFormData,setRoleFormData]=useState<any>(roledetails);
  const [facilityFormData,setfacilityFormData]=useState<any>(facility_details_for_Facility);
  const [fieldFormData,setfieldFormData]=useState<any>(facility_details_for_field);
  const [hfrVerifyFormData,setHfrVerifyFormData]=useState<any>(hfrVerify);

// new window code - create new user
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [isFormValidated, setIsFormValidated] = useState<boolean>(false);
  const [formCompleted, setFormCompleted] = useState<boolean[]>(
    Array(navItemsModal.length).fill(false),
  );
  const [closeModal,setCloseModal]=useState<boolean>(false)

  const [selectPerc, setSelectedPerc] = useState<any>(0);
  const navs = 100 / navItemsModal.length;
  const [errors, setErrors] = useState<boolean[]>([]);

   const setIsFieldDisabledOrRequired = (roleDetails: any, properties: { [key: string]: any }, ...keys: string[]) => {
    return keys.reduce((acc, key) => {
      acc[key] = { ...roleDetails[key], ...properties };
      return acc;
    }, { ...roleDetails });
  };

  const handleFormChange1 = (value: any, key: string, id: any, option: any, code: any) => {
    setFormCompleted(Array(navItemsModal.length).fill(false));
    if(key==='abha_id'){
      dispatch(updateForm("hfr",value));
    }
    if(key==='fName'){
      dispatch(updateForm("fName",value));
    }
    if(key==='lName'){
      dispatch(updateForm("lName",value));
    }
    else if(key==='hpr_id'){
      dispatch(updateForm("hfrAbha",value));
    }

    setFormState1((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));

    if (key === 'user_type' && value === 'Facility Level User') {
      setIsFacilityLevelUser(true);
      setIsFieldLevelUser(false);
    } else if (key === 'user_type' && value === 'Field Level User') {
      setIsFacilityLevelUser(false);
      setIsFieldLevelUser(true);
    } else if (key === 'user_type') {
      setIsFacilityLevelUser(false);
      setIsFieldLevelUser(false);
    }
  };
  //userPage2

  const handleFormChange2 = (value: string | boolean, key: string,option?:any,id?:any,code?:any, compositeRoleId?:any) => {
    setFormCompleted([true,false]);
    if(key==='rural_urban') {
      setRuralUrban(value) ;
      setRuralUrbanId(id);
    }
        setRoleFormState((prevState: any) => ({
          ...prevState,
          [key]: {
            ...prevState[key],
            value: value,
            isError: false,
            message: '',
            id:id,
            code:code,
            compositeRoleId:compositeRoleId,
          },
        }));
      setFormStateForFacility((facilityState:any)=>({
        ...facilityState,
        health_facility_type:{
          ...facilityState.health_facility_type,
          value:'',
        },
        health_facility_name:{
          ...facilityState.health_facility_name,
          value:'',
        },
        hfr_id:{
          ...facilityState.hfr_id,
          value:'',
        }  
    }));
    setFormStateForFacility((facilityState:any)=>({
      ...facilityState,
      hfr_id:{
        ...facilityState.hfr_id,
        value:'',
      },
      health_facility_type:{
        ...facilityState.health_facility_type,
        value:'',
        id:'',
      },
      health_facility_name:{
        ...facilityState.health_facility_name,
        value:'',
        id:'',
      },
      health_provider_tagged:{
        ...facilityState.health_provider_tagged,
        value:'',
        id:[],
      },
      mobiliser_tagged:{
        ...facilityState.mobiliser_tagged,
        value:'',
        id:[],
      },
      ward:{
        ...facilityState.ward,
        value:'',
        id:[],
        code:[]
      },
      village:{
        ...facilityState.village,
        value:'',
        id:[],
        code:[]
      },
      gram_panchayat:{
        ...facilityState.gram_panchayat,
        value:'',
        id:[],
        code:[]
      },
      volunteerForPmsma:{
        ...facilityState.volunteerForPmsma,
        value:false
      }  
  }));
    setFormStateForField((facilityState:any)=>({
      ...facilityState,
      hfr_id:{
        ...facilityState.hfr_id,
        value:'',
      },
      health_facility_type:{
        ...facilityState.health_facility_type,
        value:'',
        id:'',
      },
      health_facility_name:{
        ...facilityState.health_facility_name,
        value:'',
        id:'',
      },
      health_provider_tagged:{
        ...facilityState.health_provider_tagged,
        value:'',
        id:[],
      },
      mobiliser_tagged:{
        ...facilityState.mobiliser_tagged,
        value:'',
        id:[],
      },
      ward:{
        ...facilityState.ward,
        value:'',
        id:[],
        code:[]
      },
      village:{
        ...facilityState.village,
        value:'',
        id:[],
        code:[]
      },  
      gram_panchayat:{
        ...facilityState.gram_panchayat,
        value:'',
        id:[],
        code:[]
      }, 
  }))
  };


  //userPage3
  const setFacilityByFacilityType = async (type_id:string, value:any) =>{
    const updatedOptions= initialFacilityNames?.facilityOptions?.filter((option:any)=>option.fac_type_id  === type_id);
    setfacilityFormData((facilityFormData:any)=>({
      ...facilityFormData,
      health_facility_name:{
        ...facilityFormData.health_facility_name,
        '#options':updatedOptions,
      }
    }));
    setfieldFormData((facilityFormData:any)=>({
      ...facilityFormData,
      health_facility_name:{
        ...facilityFormData.health_facility_name,
        '#options':updatedOptions,
      }
    }));
    if(value === undefined || value === '')
    {
      setfacilityFormData((facilityFormData:any)=>({
        ...facilityFormData,
        health_facility_name:{
          ...facilityFormData.health_facility_name,
          '#options':initialFacilityNames.facilityOptions,
        }
      }));
      setfieldFormData((facilityFormData:any)=>({
        ...facilityFormData,
        health_facility_name:{
          ...facilityFormData.health_facility_name,
          '#options':initialFacilityNames.facilityOptions,
        }
      }));
    }
  }

  const setFacilityByFacilityName = async (type_id:string) =>{
    const updatedOptions= intialFacilityTypes?.facilityTypeOptions?.filter((option:any)=>option.id  === type_id);
    const selectedFacilitytype = updatedOptions?.[0]?.value;
    setFormStateForFacility((facilityState:any)=>({
      ...facilityState,
      health_facility_type:{
        ...facilityState.health_facility_type,
        value:selectedFacilitytype,
      }
    }));
    setFormStateForField((facilityState:any)=>({
      ...facilityState,
      health_facility_type:{
        ...facilityState.health_facility_type,
        value:selectedFacilitytype,
      }
    }))
  }

  const setHFRValue = async (hfrID:string, value:any)=>{
    setFormStateForFacility((facilityState:any)=>({
      ...facilityState,
      hfr_id:{
        ...facilityState.hfr_id,
        value:hfrID,
      }
    }));
    setFormStateForField((facilityState:any)=>({
      ...facilityState,
      hfr_id:{
        ...facilityState.hfr_id,
        value:hfrID,
      }
    }));
    setHfrVerifyFormData((hfrVerifyFormData:any) => ({
      hfrId:{
        ...hfrVerifyFormData.hfrId,
        '#isDisabled':hfrID ? true : false,
      }
    }))
    if(value === undefined || value === '')
      {
        setFormStateForFacility((facilityState:any)=>({
          ...facilityState,
          hfr_id:{
            ...facilityState.hfr_id,
            value:'',
          }
        }));
        setFormStateForField((facilityState:any)=>({
          ...facilityState,
          hfr_id:{
            ...facilityState.hfr_id,
            value:'',
          }
        }));
    }

  }

  const handleFormChange3 = (value: string | boolean, key: string,id?:any,option?:any,code?:any) => {
    setFormCompleted([true,true,false]);
    if(formState1.user_type.value==='Facility Level User'){
      setFormStateForFacility((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          id:id,
          isError: false,
            message: '',
            code:code
        },
      }));
    }
    else{
      setFormStateForField((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          id:id,
          code:code,
          isError: false,
          message: '',

        },
      }));
    }
    if(key === 'health_facility_type'){
      setFacilityByFacilityType(id, value);
      setFormStateForFacility((facilityState:any)=>({
        ...facilityState,
        health_facility_name:{
          ...facilityState.health_facility_name,
          value:'',
        },
        hfr_id:{
          ...facilityState.hfr_id,
          value:'',
        },
        mobiliser_tagged:{
          ...facilityState.mobiliser_tagged,
          value:[],
        },

      }));
      setFormStateForField((facilityState:any)=>({
        ...facilityState,
        health_facility_name:{
          ...facilityState.health_facility_name,
          value:'',
        },
        hfr_id:{
          ...facilityState.hfr_id,
          value:'',
        },
        health_provider_tagged:{
          ...facilityState.health_provider_tagged,
          value:[],
          id: [],
        },
      }));
      setHfrVerifyFormData((hfrVerifyFormData:any) => ({
      hfrId:{
        ...hfrVerifyFormData.hfrId,
        '#isDisabled':false,
      }
    }))
    }
    if(key === 'health_facility_name'){
      const selectedfacility = option?.filter((op:any)=>(op?.id === id));
      const facilityID = selectedfacility?.[0]?.fac_type_id;
      let hfrID = '';
      if(selectedfacility?.[0]?.hfr_id === null || selectedfacility?.[0]?.hfr_id === undefined)
      {
        hfrID = '';
      }
      else{
        hfrID = selectedfacility?.[0]?.hfr_id
      }
      setFacilityByFacilityName(facilityID);
      setHFRValue(hfrID, value);
      setFormStateForFacility((facilityState:any)=>({
        ...facilityState,
        mobiliser_tagged:{
          ...facilityState.mobiliser_tagged,
          value:[],
        },
        village:{
          ...facilityState.village,
          value:[],
          id:[],
          code:[]
        },
        gram_panchayat:{
          ...facilityState.gram_panchayat,
          value:[],
          id:[],
          code:[]
        },
        ward:{
          ...facilityState.ward,
          value:[],
          id:[],
          code:[]
        }
      }));
      setFormStateForField((facilityState:any)=>({
        ...facilityState,
        health_provider_tagged:{
          ...facilityState.health_provider_tagged,
          value:[],
          id: [],
        },
        village:{
          ...facilityState.village,
          value:[],
          id: [],
          code:[]
        },
        gram_panchayat:{
          ...facilityState.gram_panchayat,
          value:[],
          id: [],
          code:[]
        },
        ward:{
          ...facilityState.ward,
          value:[],
          id: [],
          code:[]
        }
      }));
    }
    if(key === 'hfr_id'){
      if(value === ''){
        setFacilityByFacilityType('', '');
        setFormStateForFacility((facilityState:any)=>({
          ...facilityState,
          health_facility_type:{
            ...facilityState.health_facility_type,
            value:'',
            id:'',
          },
        }));
        setFormStateForField((facilityState:any)=>({
          ...facilityState,
          health_facility_type:{
            ...facilityState.health_facility_type,
            value:'',
            id:'',
          },
        }));
      }
      let facilityNameOptions:any= [];
      if(option){
        facilityNameOptions = [{
          value: `${option?.facility_name}`,
          label: `${option?.facility_name}`,
          id: `${option?.facilit_id}`,
          code:``,
        }];
        setfacilityFormData((facilityFormData:any) => ({
        ...facilityFormData,
        health_facility_name:{
          ...facilityFormData.health_facility_name,
          '#options':facilityNameOptions
        },
      }));
      setfieldFormData((facilityFormData:any) => ({
        ...facilityFormData,
        health_facility_name:{
          ...facilityFormData.health_facility_name,
          '#options':facilityNameOptions
        },
      }));
      }
      setFormStateForFacility((facilityState:any)=>({
        ...facilityState,
        health_facility_name:{
          ...facilityState.health_facility_name,
          value:option?.facility_name,
          id:option?.facilit_id,
        },
      }));
      setFormStateForField((facilityState:any)=>({
        ...facilityState,
        health_facility_name:{
          ...facilityState.health_facility_name,
          value:option?.facility_name,
          id:option?.facilit_id,
        },
      }));
    }
    }

  const getHealthProviderTagged=async(facility_id:any) =>{
    try {
      const response = await axios.get(`${endpoints.getHealthProviderTagged(facility_id)}`, Auth.loggedIn());
      const taggedHP = response?.data?.data;
        if (response.status === 200 && taggedHP.length > 0) {
          const taggedHPOptions = taggedHP.map((key: any) => ({
            value: `${key.f_name} ${key.l_name}`,
            label: `${key.f_name} ${key.l_name}`,
            id: key.user_id,
            code:key.user_code,
          }));
          setfieldFormData((facilityFormData:any) => ({
            ...facilityFormData,
            health_provider_tagged:{
              ...facilityFormData.health_provider_tagged,
              '#options':taggedHPOptions
            },
          }))
        }
        else{
          setfieldFormData((facilityFormData:any) => ({
            ...facilityFormData,
            health_provider_tagged:{
              ...facilityFormData.health_provider_tagged,
              '#options':[]
            },
          }))
        }
    }     catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }

  const getASHAMobiliserTagged=async(facility_id:any) =>{
    try {
      const response = await axios.get(`${endpoints.getASHAMobiliserTagged(facility_id)}`, Auth.loggedIn());
      const taggedASHA = response?.data?.data;
        if (response.status === 200 && taggedASHA.length > 0) {
          const taggedASHAOptions = taggedASHA.map((key: any) => ({
            value: `${key.f_name} ${key.l_name}`,
            label: `${key.f_name} ${key.l_name}`,
            id: key.user_id,
            code:key.user_code,
          }));
          setfacilityFormData((facilityFormData:any) => ({
            ...facilityFormData,
            mobiliser_tagged:{
              ...facilityFormData.mobiliser_tagged,
              '#options':taggedASHAOptions
            },
          }))
        }
        else{
          setfacilityFormData((facilityFormData:any) => ({
            ...facilityFormData,
            mobiliser_tagged:{
              ...facilityFormData.mobiliser_tagged,
              '#options':[]
            },
          }))
        }
    }     catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }

    useEffect(()=>{
      if(isFacilityLevelUser){
        const facilityId = formStateForFacility?.health_facility_name?.id;
        if(facilityId){
          getASHAMobiliserTagged(facilityId);    //'bf426274-d06a-40fb-aa3c-1fe8d3c3bcf1'
        }
      } 
      if(isFieldLevelUser)
      {
        // const facilityId = formStateForField?.health_facility_name?.id;
        if(formStateForField?.health_facility_name?.id){
          getHealthProviderTagged(formStateForField?.health_facility_name?.id);   //'bf426274-d06a-40fb-aa3c-1fe8d3c3bcf1'
        }
      }
    },[formStateForFacility?.health_facility_name?.id, formStateForField?.health_facility_name?.id])

  //Get UserTypes
  useEffect(()=>{
    const userTypeId = localStorage.getItem('userTypeId');
    getUserType(userTypeId);
    checkIfUsingGramPanchayat();
  },[])
  const getUserType =async(userTypeId:any)=>{
    try{
    const usertypes = await getDataWithCache<any[]>(`${endpoints.getAllUserTypesWithContext}/${userTypeId}`)
   const usertypesOptions = usertypes.data.map((key: any) => ({
      value: key.usertype_name,
      label: key.usertype_name,
      id: key.usertype_id,
      code:key.usertype_code,
    }));
    setUserData((user_details:any) => ({
      ...user_details,
      user_type:{
        ...user_details.user_type,
        '#options': usertypesOptions,
      },
      designation:{
        ...user_details.designation,
        '#options': [],
      },
    }))
  }
  catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }

  //function to reset all value state
  function resetRoleFormState(fieldsToUpdate: string[]) {
    setRoleFormState((roleState: any) => {
      const updatedState = { ...roleState };
      fieldsToUpdate.forEach((field) => {
        updatedState[field] = {
          value: '',
          id: '',
          code: '',
          message: '',
          isError: false,
        };
      });
      return updatedState;
    });
  }

  const findMatchedOption = (options: any[] = [], id: any) => {
    if (!id || !options?.length) return undefined;
    return options.find((option: any) => String(option.id) === String(id));
  };

  useEffect(()=>{
    formState1.user_type.id && getUserDesignation(formState1.user_type.id);
    formState1.designation.value ='';
    setRuralUrban('');
    setRuralUrbanId('');
    let fieldsToReset:any =[];
    switch(userTypeName){
      case 'Super Admin User':{
        fieldsToReset = ['role_name','state','zone_div_circle','district','sub_district','sub_division','health_block','rural_urban','ulb','ward','block','village','gram_panchayat'];
        break;
      };
      case 'National Level User':{
        fieldsToReset = ['role_name','state','zone_div_circle','district','sub_district','sub_division','health_block','rural_urban','ulb','ward','block','village','gram_panchayat'];
        break;
      };
      case 'State Level User':{
        fieldsToReset = ['role_name','zone_div_circle','district','sub_district','sub_division','health_block','rural_urban','ulb','ward','block','village','gram_panchayat'];
        break;
      };
      case 'District Level User':{
        fieldsToReset = ['role_name','zone_div_circle','sub_district','sub_division','health_block','rural_urban','ulb','ward','block','village','gram_panchayat'];
        break;
      };
      default:{
        fieldsToReset = ['role_name','zone_div_circle','sub_district','sub_division','health_block','rural_urban','ulb','ward','block','village','gram_panchayat'];
        break;
      }
    }
    resetRoleFormState(fieldsToReset);
    if(formState1.user_type.value==='Super Admin User'){
      const fieldsToUpdate = ['state','zone_div_circle','district','sub_district','sub_division','health_block','rural_urban','ulb','ward','block','village','gram_panchayat'];
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':false,
          '#isDisabled':true,
        },
         ...fieldsToUpdate)
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':false,
          '#isDisabled':false,
        },
        'role_name'
      )));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#multiDropdown':false,
        },
        'zone_div_circle')
      ));
    }
    else if(formState1.user_type.value==='National Level User'){
      const fieldsToUpdate = ['state','zone_div_circle', 'district','sub_district','sub_division','health_block', 'rural_urban', 'ulb','ward','block','village','gram_panchayat']
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':false,
          '#isDisabled':true,
        },
        ...fieldsToUpdate)
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
          '#isDisabled':false,
        },
        'role_name'
      )));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#multiDropdown':false,
        },
        'zone_div_circle')
      ));
    }
    else if(formState1.user_type.value==='State Level User'){
      const fieldsToUpdate = ['zone_div_circle','sub_district','sub_division','health_block', 'rural_urban', 'ulb','ward','block','village','gram_panchayat']
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':false,
          '#isDisabled':true,
        },
        ...fieldsToUpdate)
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
          '#isDisabled':false,
        },
        'district')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
          '#isDisabled':(!['Super Admin User', 'National Level User'].includes(userTypeName)) ? true : false,
        },
        'state')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#multiDropdown':false,
        },
        'zone_div_circle')
      ));
    }
    else if(formState1.user_type.value === 'Zone / Circle / Region / Division Level User'){
      const fieldsToUpdate = ['district','sub_district','sub_division','health_block', 'rural_urban', 'ulb','ward','block','village','gram_panchayat']
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':false,
          '#isDisabled':true,
        },
        ...fieldsToUpdate)
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
          '#isDisabled':(!['Super Admin User', 'National Level User'].includes(userTypeName)) ? true : false,
        },
        'state')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#multiDropdown':true,
          '#required':true,
          '#isDisabled':false,
        },
        'zone_div_circle')
      ));
    }
    else if(formState1.user_type.value==='District Level User'){
      const fieldsToUpdate = ['sub_district','sub_division','health_block', 'rural_urban', 'ulb','ward','block','village','gram_panchayat'];
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':false,
          '#isDisabled':true,
        },
        ...fieldsToUpdate)
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#multiDropdown':false,
          // '#required':false,
          '#isDisabled':false,
        },
        'zone_div_circle')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
          '#isDisabled':(!['Super Admin User', 'National Level User','State Level User'].includes(userTypeName)) ? (roleFormData.district['#options'].length >= 1 ? false : true) : false,
        },
        'state','district')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
          '#isDisabled':(['District Level User'].includes(userTypeName)) ? true : false
        },
        'state','district')
      ));
    }
    else if(formState1.user_type.value==='ULB Level User'){
      setRuralUrban('Urban');
      setRuralUrbanId('faf5bda0-4c2b-45ac-afd2-33e97d985d3e');
      const fieldsToUpdate = ['district','sub_district','sub_division','health_block', 'rural_urban','block','village','ward','gram_panchayat']
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':false,
          '#isDisabled':true,
        },
        ...fieldsToUpdate
        )
      ));
      setRoleFormState((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          'value':'Urban',
          'id':'faf5bda0-4c2b-45ac-afd2-33e97d985d3e',
          },
        'rural_urban')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#multiDropdown':false,
          '#required':false,
          '#isDisabled':false,
        },
        'zone_div_circle')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
          '#isDisabled':(!['Super Admin User', 'National Level User'].includes(userTypeName)) ? true : false,
        },
        'state')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
          '#isDisabled':true, 
        },
        'ulb')
      ));
    }
    else if(formState1.user_type.value==='Sub-District Level User'){
      const fieldsToUpdate = ['ulb','sub_division','health_block', 'rural_urban','ward','block','village','gram_panchayat'];
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':false,
          '#isDisabled':true,
        },
        ...fieldsToUpdate)
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#multiDropdown':false,
          '#required':false,
          '#isDisabled':false,
        },
        'zone_div_circle')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
          '#isDisabled':(!['Super Admin User', 'National Level User'].includes(userTypeName)) ? true : false,
        },
        'state','district')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
          '#isDisabled':false,
        },
        'sub_district')
      ));
    }
    else if(formState1.user_type.value==='Block Level User'){
      setRuralUrban('Rural');
      setRuralUrbanId('4485c41d-2142-43a2-b6d2-735b58caef09');
      const fieldsToUpdate = ['sub_division','health_block','ulb', 'rural_urban','ward','gram_panchayat'];
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':false,
          '#isDisabled':true,
        },
      ...fieldsToUpdate)
      ));
      setRoleFormState((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          'value':'Rural',
          'id':'4485c41d-2142-43a2-b6d2-735b58caef09',
          },
        'rural_urban')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#multiDropdown':false,
          '#required':false,
          '#isDisabled':false,
        },
        'zone_div_circle')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
          '#isDisabled':(!['Super Admin User', 'National Level User'].includes(userTypeName)) ? true : false,
        },
        'state','district')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
          '#isDisabled':false,
        },
        'sub_district','block')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':false,
          '#isDisabled':true,
        },
        'village')
      ));
    }
    else if(formState1.user_type.value==='Health Block/ Sub Division Level User'){
      const fieldsToUpdate = ['ulb','sub_district','block','rural_urban','ward','village','gram_panchayat'];
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':false,
          '#isDisabled':true,
        },
         ...fieldsToUpdate)
      ));
        setRoleFormData((roleDetails: any) => (
          setIsFieldDisabledOrRequired(roleDetails, {
            '#required': true,
            '#isDisabled': false,
          },
            'sub_division', 'health_block')
        ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#multiDropdown':false,
          '#required':false,
          '#isDisabled':false,
        },
        'zone_div_circle')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
          '#isDisabled':(!['Super Admin User', 'National Level User'].includes(userTypeName)) ? true : false,
        },
        'state','district')
      ));
    }
    else if(formState1.user_type.value==='Facility Level User' || formState1.user_type.value==='Field Level User'){
      const fieldsToUpdate = ['sub_division','health_block','sub_district','rural_urban'];
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#isDisabled':false,
        },
        ...fieldsToUpdate)
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#isDisabled': false,
        },
        'ulb','ward')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#isDisabled':true,
        },
        'block','village','gram_panchayat'
      )));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#isDisabled':(!['Super Admin User', 'National Level User'].includes(userTypeName)) ? true : false,
        },
        'state'
      )));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#isDisabled':(!['Super Admin User', 'National Level User', 'State Level User'].includes(userTypeName)) ? true : false,
        },
        'district'
      )));
      const loggedRuralUrbanName = loggedInUserDetails?.urban_rural_name?.toLowerCase();
      const loggedRuralUrbanMatch = (roleFormData?.rural_urban?.['#options'] || []).find((option:any) => option.value?.toLowerCase() === loggedRuralUrbanName);
      if (loggedRuralUrbanMatch) {
        setRuralUrban(loggedRuralUrbanMatch.value);
        setRuralUrbanId(loggedRuralUrbanMatch.id);
        // resetRoleFormState() above always blanks rural_urban, so re-apply the match directly (setRuralUrban alone is a no-op when the value hasn't changed)
        setRoleFormState((roleFormState:any) => ({
          ...roleFormState,
          rural_urban: {
            ...roleFormState.rural_urban,
            value: loggedRuralUrbanMatch.value,
            id: loggedRuralUrbanMatch.id,
            code: loggedRuralUrbanMatch.code ?? roleFormState.rural_urban?.code ?? '',
            isError: false,
            message: '',
          },
        }));
      } else {
        
        setRuralUrban('');
      
      }
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#isDisabled': loggedRuralUrbanMatch ? true : false, // locked only when it's the logged-in user's own rural/urban
        },
        'rural_urban')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':true,
        },
        'state','district','rural_urban'
      )));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required':false,
        },
        'sub_division','health_block',
      )));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#multiDropdown':false,
          '#required':false,
          '#isDisabled':false,
        },
        'zone_div_circle')
      ));
    }
  },[formState1.user_type.value])

  useEffect(() => {
    if(formState1.user_type.value==='Health Block/ Sub Division Level User'){
    if(!roleFormState.health_block.value && !roleFormState.sub_division.value) {
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required': true,
          '#isDisabled': false,
        },
          'sub_division', 'health_block')
      ));
    }
    else if(roleFormState.health_block.value && !roleFormState.sub_division.value){
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required': false,
          '#isDisabled': false,
        },
          'sub_division')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required': true,
          '#isDisabled': false,
        },
          'health_block')
      ));
      setRoleFormState((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          'message':'',
          'isError':false,
        },
          'sub_division','health_block')
      ));
    }
    else if(!roleFormState.health_block.value && roleFormState.sub_division.value) {
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required': false,
          '#isDisabled': false,
        },
          'health_block')
      ));
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required': true,
          '#isDisabled': false,
        },
          'sub_division')
      ));
      setRoleFormState((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          'message':'',
          'isError':false,
        },
          'sub_division','health_block')
      ));
    }
    else{
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#required': true,
          '#isDisabled': false,
        },
          'sub_division', 'health_block')
      ));
    }
  }
  },[roleFormState.health_block.value, roleFormState.sub_division.value])
  
  useEffect(()=>{
    if(roleFormState.offlineModeAccess.value===true){
    setRoleFormData((role_details:any) => ({
      ...role_details,
      mfa:{
        ...role_details?.mfa,
        '#isDisabled':true,
       
      },
    }));
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      mfa: {
        ...roleFormState.mfa,
        value: false,
        
      },
    }));
  }
  else{
    setRoleFormData((role_details:any) => ({
      ...role_details,
      mfa:{
        ...role_details?.mfa,
        '#isDisabled':false,
      },
    }));
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      mfa: {
        ...roleFormState.mfa,
        value: true,
        
      },
    }));
  }
  },[roleFormState.offlineModeAccess.value])

  useEffect(()=>{
    if(formState1?.user_type?.value ==='Facility Level User' || formState1?.user_type?.value ==='Field Level User'){
      if(formState1?.designation?.value === "Community Health Officer - CHO" || formState1?.designation?.value === "ANM" || formState1?.designation?.value === "ASHA"){
          setRoleFormData((role_details:any) => ({
            ...role_details,
            offlineModeAccess:{
              ...role_details?.offlineModeAccess,
              '#isDisabled':false,
              '#isVisible':'isVisible',
            },
          }));
      }
      else{
          setRoleFormData((role_details:any) => ({
            ...role_details,
            offlineModeAccess:{
              ...role_details?.offlineModeAccess,
              '#isDisabled':true,
              '#isVisible':'isNotVisible',
            },
          }));
          setRoleFormState((roleFormState:any) => ({
            ...roleFormState,
            offlineModeAccess: {
              ...roleFormState.offlineModeAccess,
              value: false,         
            },
          }));
        }  
    }
    else{
      setRoleFormData((role_details:any) => ({
        ...role_details,
        offlineModeAccess:{
          ...role_details?.offlineModeAccess,
          '#isDisabled':true,
          '#isVisible':'isNotVisible',
        },
      }));
      setRoleFormState((roleFormState:any) => ({
        ...roleFormState,
        offlineModeAccess: {
          ...roleFormState.offlineModeAccess,
          value: false,         
        },
      }));
    }
  },[formState1?.user_type?.value, formState1?.designation?.value])
  const getUserDesignation =async(userTypeId:any)=>{
    try{

    const userDesignation = await getData<any[]>(`${endpoints.getUserDesignationWithContext}/${userTypeId}`)
   const userDesignationOptions = userDesignation.data.map((key: any) => ({
      value: key.user_designation_name,
      label: key.user_designation_name,
      id: key.user_designation_id,
      code:key.user_designation_code,
    }));
    setUserData((user_details:any) => ({
      ...user_details,
      designation:{
        ...user_details.designation,
        '#options': userDesignationOptions,
      },
    }))
    
  }
  catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }

  
  useEffect(()=> {

    if(formState1.user_type.value === 'Facility Level User' || formState1.user_type.value === 'Field Level User'){
      setnavItemsModal(['User Details', 'Role & Hierarchy Details', 'Facility Details']); 
    }else{
      setnavItemsModal(['User Details', 'Role & Hierarchy Details']); 
    }
    if(formState1.user_type.value === 'Facility Level User'){
      dispatch(updateForm("hfrAbha",''));

      setfacilityFormData((facilityFormData:any) => ({
        ...facilityFormData,
        health_provider_tagged:{
          ...facilityFormData.health_provider_tagged,
          '#isDisabled':true,
          '#options':[]  
        },
        mobiliser_tagged:{
          ...facilityFormData.mobiliser_tagged,
          '#isDisabled':false,
          '#options':[]  
        }
      }))


    }else{
      dispatch(updateForm("hfrAbha",''));
      setfieldFormData((fieldFormData: any) => ({
        ...fieldFormData,

        health_provider_tagged:{
          ...facilityFormData.health_provider_tagged,
          '#isDisabled':false,
          '#options':[] 
        },
        mobiliser_tagged:{
          ...facilityFormData.mobiliser_tagged,
          '#isDisabled':true,
          '#options':[]  
        }
      }));
      setUserData((prevState: any) => ({
        ...prevState,
        user_status: {
          ...prevState.user_status,
          '#isDisabled': false,
          '#required': true,
        }
      }));
      setFormState1((formState1: any) => ({
        ...formState1,
        user_status:{
          ...formState1.user_status,
          value:true
        },
       
      }));
    }
  
  if(formState1.user_type.value === 'Facility Level User'){
      if (formState1.designation.value === 'MPW/MPHW') {
        dispatch(updateForm("hfrAbha", ''));
        setUserData((prevState: any) => ({
          ...prevState,
          hpr_id: {
            '#type': 'verifyHPR',
            '#isDisabled': true,
            '#title': 'ABHA Number',
            '#webform_key': 'abha_id',
            '#required': true,
          },
          user_status: {
            ...prevState.user_status,
            '#isDisabled': true,
            '#required': true,
          }
        }));
        setFormState1((prevState: any) => ({
          ...prevState,
          ['hpr_id']: {
            ...prevState['hpr_id'],
            value: '',
            id: 0,
            code: 0,
            isError: false,
            message: '',
          }
        }));
        setFormState1((formState1: any) => ({
          ...formState1,
          user_status: {
            ...formState1.user_status,
            value: false
          },
        }));
      }
    else if(formState1.designation.value!=='Hospital Adminstrator - DH and SDH' && formState1.designation.value!=='Hospital Administrator - Other Central government hospitals' &&        
    formState1.designation.value!=='Medical Director' && formState1.designation.value!=='Medical Supritendent'
    ){
    dispatch(updateForm("hfrAbha",''));

    setUserData((prevState: any) => ({
      ...prevState,
     
      hpr_id: {
        '#type': 'verifyHPR',
        '#isDisabled': false,
        '#title':'HPR ID',
        '#webform_key': 'hpr_id',
        '#required': true,
      },
      user_status: {
        ...prevState.user_status,
        '#isDisabled': true,
        '#required': true,
      }
    }));
    setFormState1((prevState: any) => ({
      ...prevState,
      ['hpr_id']: {
        ...prevState['hpr_id'],
        value: '',
        id: 0,
        code: 0,
        isError: false,
        message: '',
      },
    }));
    setFormState1((formState1: any) => ({
      ...formState1,
      user_status:{
        ...formState1.user_status,
        value:false
      },
     
    }));
  }
  else{
    dispatch(updateForm("hfrAbha",''));
    dispatch(updateForm('designation',''));
    setUserData((prevState: any) => ({
      ...prevState,
     
      hpr_id: {
        '#type': 'verifyHPR',
        '#isDisabled': true,
        '#title':'HPR ID',
        '#webform_key': 'hpr_id',
        '#required': true,
      },
      user_status: {
        ...prevState.user_status,
        '#isDisabled': false,
        '#required': true,
      }
    }));
    setFormState1((prevState: any) => ({
      ...prevState,
      ['hpr_id']: {
        ...prevState['hpr_id'],
        value: '',
        id: 0,
        code: 0,
        isError: false,
        message: '',
      },
    }));
    setFormState1((formState1: any) => ({
      ...formState1,
      user_status:{
        ...formState1.user_status,
        value:true
      },
     
    }));
  }
    

  }
  else if(formState1.user_type.value === 'Field Level User'){
   
    dispatch(updateForm("hfrAbha",''));

    setUserData((prevState: any) => ({
      ...prevState,
      
      hpr_id: {
        '#type': 'verifyHPR',
        '#isDisabled': true,
        '#title':'ABHA Number',
        '#webform_key': 'abha_id',
        '#required': true,
      },
      user_status: {
        ...prevState.user_status,
        '#isDisabled': true,
        '#required': true,
      }
    }));
    setFormState1((prevState: any) => ({
      ...prevState,
      ['hpr_id']: {
        ...prevState['hpr_id'],
        value: '',
        id: 0,
        code: 0,
        isError: false,
        message: '',
      }
    }));
    setFormState1((formState1: any) => ({
      ...formState1,
      user_status:{
        ...formState1.user_status,
        value:false
      },
     
    }));
  

  }
  else{

    setUserData((prevState: any) => ({
      ...prevState,
      hpr_id: {
        '#webform_key': 'hpr_id',
        '#required': true,
        '#isDisabled': true,
        '#type': 'verifyHPR',
        '#title':'HPR ID/ABHA Number'
      }
    }));
    setFormState1((prevState: any) => ({
      ...prevState,
      ['hpr_id']: {
        ...prevState['hpr_id'],
        value: '',
        id: 0,
        code: 0,
        isError: false,
        message: '',
      },
    }));
  }

  if(formState1.user_type.value === 'Facility Level User' && formState1.designation.value === 'MPW/MPHW'){
    dispatch(updateForm('userType','Facility Level User'))
    dispatch(updateForm('designation','MPW/MPHW'));
    dispatch(updateForm("hfrAbha",''));
  }
  else if(formState1.user_type.value === 'Facility Level User' && formState1.designation.value !== 'MPW/MPHW'){
    dispatch(updateForm('userType','Facility Level User'))
    dispatch(updateForm("hfrAbha",''));
  }
  else if(formState1.user_type.value === 'Field Level User'){
    dispatch(updateForm('userType','Field Level User'))
    dispatch(updateForm('designation', formState1.designation.value));
    dispatch(updateForm("hfrAbha",''));
  }
  if(!formState1.user_type.value){
    dispatch(updateForm('userType',''))
  }
  if(!formState1.designation.value){
     dispatch(updateForm('designation',''));
  }
  },[formState1.user_type.value,formState1.designation.value]);
  //setting status for field and facility level users
  useEffect(()=>{
    
      if(isVerified==='true'){
        if(formState1.user_type.value==='Facility Level User' && formState1.designation.value !== 'MPW/MPHW'){
          setFormState1((formState1: any) => ({
            ...formState1,
            user_status:{
              ...formState1.user_status,
              value:true
            },
            hpr_id:{
              ...formState1.hpr_id,
              value:hfrAbhaId
            }
           
          }));
          setUserData((user_details:any) => ({
            ...user_details,
            fName:{
              ...user_details.fName,
              '#required': false,
              '#isDisabled':true,

            },
            lName:{
              ...user_details.lName,
              '#isDisabled':true,
              '#required': false,
            },
            hpr_id:{
              ...user_details.hpr_id,
              '#isDisabled':true,
            },
          }))
        }
        else if(formState1.user_type.value==='Field Level User' || (formState1.user_type.value==='Facility Level User' && formState1.designation.value === 'MPW/MPHW')){
          setFormState1((formState1: any) => ({
            ...formState1,
            user_status:{
              ...formState1.user_status,
              value:true
            },
            abha_id:{
              ...formState1.abha_id,
              value:hfrAbhaId
            }
           
          }));
          setUserData((user_details:any) => ({
            ...user_details,
            fName:{
              ...user_details.fName,
              '#required': false,
              '#isDisabled':true,

            },
            lName:{
              ...user_details.lName,
              '#isDisabled':true,
              '#required': false,
            },
          }))
        }
       
      }
      else{
       if(formState1.user_type.value==='Facility Level User' && formState1.designation.value !== 'MPW/MPHW'){
        setFormState1((formState1: any) => ({
          ...formState1,
          user_status:{
            ...formState1.user_status,
            value:false
          },
          hpr_id:{
            ...formState1.hpr_id,
            value:hfrAbhaId
          }
         
        }));
        setAlertModalOpen(true);

       }
       else if(formState1.user_type.value==='Field Level User' || (formState1.user_type.value==='Facility Level User' && formState1.designation.value === 'MPW/MPHW')){
        setFormState1((formState1: any) => ({
          ...formState1,
          user_status:{
            ...formState1.user_status,
            value:false
          },
          hpr_id:{
            ...formState1.hpr_id,
            value:hfrAbhaId
          }
         
        }));
       }
      }
    
    
  },[isVerified]);

  useEffect(() => {
    if (faceAuthVerifiedMob) {
      setFormState1((prev: any) => ({
        ...prev,
        mob: {
          ...prev.mob,
          value: faceAuthVerifiedMob,
        },
      }));
    }
  }, [faceAuthVerifiedMob]);




  useEffect(()=>{
   setRoleFormState((prevState: any) => ({
    ...prevState,
    ['rural_urban']: {
      ...prevState['rural_urban'],
      value: ruralUrban,
      isError: false,
      message: '',
      id:ruralUrbanId
    },
  }));
    const shouldEnableBlockSelection = [USER_TYPES.BLOCK_LEVEL_USER, USER_TYPES.FACILITY_LEVEL_USER, USER_TYPES.FIELD_LEVEL_USER].includes(formState1.user_type.value);
    const shouldEnableVillageSelection = [USER_TYPES.FACILITY_LEVEL_USER, USER_TYPES.FIELD_LEVEL_USER].includes(formState1.user_type.value);
    if(ruralUrban==='Rural'){
      setRoleFormState((roleState: any) => (
        setIsFieldDisabledOrRequired(roleState, {
          'value':'',
          'id':'',
          'code':'',
          'message':'',
          'isError':false,
        },
        'ulb','block','ward', 'village','gram_panchayat')));
      setRoleFormData((role_details:any) => ({
        ...role_details,
        ulb:{
          ...role_details?.ulb,
          '#isDisabled':true,
          '#required': false, 
        },
        ward:{
          ...role_details?.ward,
          '#isDisabled':true,
          '#required': false, 
        },
        village:{
          ...role_details?.village,
          '#isDisabled': isBlockLevelLogin ? false : (shouldEnableVillageSelection ? false : true), 
          '#required': shouldEnableVillageSelection,
        },
        gram_panchayat:{
          ...role_details?.gram_panchayat,
          '#isDisabled':false,
          '#required': true,
        },
        block:{
          ...role_details?.block,
          '#required': hasBlocksForDistrict === false ? false : shouldEnableBlockSelection,
          '#isDisabled': hasBlocksForDistrict === false ? true : (shouldEnableBlockSelection ? false : true),

        },

      }))
      setfieldFormData((facility_details:any) => ({
        ...facility_details,
        ward:{
          ...facility_details?.ward,
          '#isDisabled':true,
          '#options':[]
        },
        village:{
          ...facility_details?.village,
          '#isDisabled':false,
          '#required': fieldFormData.village['#options'].length?true:false,
        },
        gram_panchayat:{
          ...facility_details?.gram_panchayat,
          '#isDisabled':false,
          '#required': fieldFormData.gram_panchayat['#options'].length?true:false,
        },
      }))
      setfacilityFormData((facility_details:any) => ({
        ...facility_details,
        ward:{
          ...facility_details?.ward,
          '#isDisabled':true, 
          '#options':[]
        },
        village:{
          ...facility_details?.village,
          '#isDisabled':false,
          '#required': facilityFormData.village['#options'].length?true:false,
        },
        gram_panchayat:{
          ...facility_details?.gram_panchayat,
          '#isDisabled':false,
          '#required': fieldFormData.gram_panchayat['#options'].length?true:false,
        },
      }));
      setFormStateForFacility((roleFormState:any) => ({
        ...roleFormState,
        ward: {
          ...roleFormState.ward,
          value: '',
          isError:false,
          message:'',
          id:[],
          code:[]
        },
      }))
      setFormStateForField((roleFormState:any) => ({
        ...roleFormState,
        ward: {
          ...roleFormState.ward,
          value: '',
          id: [],
          code:[],
          isError:false,
          message:''
        },
      }))


     

   
   }
    else if(ruralUrban==='Urban') {
      setRoleFormState((roleState: any) => (
        setIsFieldDisabledOrRequired(roleState, {
          'value':'',
          'id':'',
          'code':'',
          'message':'',
          'isError':false,
        },
        'ulb','block','ward', 'village','gram_panchayat')));
      setRoleFormData((role_details:any) => ({
        ...role_details,
        ulb:{
          ...role_details?.ulb,
          '#isDisabled': loggedInUserDetails?.ulb_id ? true : false,
          '#required': true,
        },
        ward:{
          ...role_details?.ward,
          '#isDisabled': loggedInUserDetails?.ward_id ? true : false,
          '#required': true,
        },
        village:{
          ...role_details?.village,
          '#isDisabled':true,
          '#required': false, 
        },
        gram_panchayat:{
          ...role_details?.gram_panchayat,
          '#isDisabled':true,
          '#required': false, 
        },
        block:{
          ...role_details?.block,
          '#isDisabled':true,
          '#required': false, 
        },

      }))
      setfieldFormData((field_details:any) => ({
        ...field_details,
        ward:{
          ...field_details?.ward,
          '#isDisabled':false, 
          '#required': fieldFormData.ward['#options'].length?true:false,
        },
        village:{
          ...field_details?.village,
          '#isDisabled':true,
          '#options':[],
        },
        gram_panchayat:{
          ...field_details?.gram_panchayat,
          '#isDisabled':true,
          '#options':[],
        },
      }))
      setfacilityFormData((facility_details:any) => ({
        ...facility_details,
        ward:{
          ...facility_details?.ward,
          '#isDisabled':false,
          '#required': facilityFormData.ward['#options'].length?true:false,
        },
        village:{
          ...facility_details?.village,
          '#isDisabled':true,
          '#options':[],
        },
        gram_panchayat:{
          ...facility_details?.gram_panchayat,
          '#isDisabled':true,
          '#options':[],
        },
      }))
      setFormStateForFacility((roleFormState:any) => ({
        ...roleFormState,
        village: {
          value: '',
          isError:false,
          message:'',
          id:[],
          code:[]
        },
        gram_panchayat: {
          value: '',
          isError:false,
          message:'',
          id:[],
          code:[]
        },
      }))
      setFormStateForField((roleFormState:any) => ({
        ...roleFormState,
        village: {
          value: '',
          id: [],
          code:[],
          isError:false,
          message:''
        },
        gram_panchayat: {
          value: '',
          id: [],
          code:[],
          isError:false,
          message:''
        },
      }))
      
    }
    else if(ruralUrban==='' || ruralUrban === null || ruralUrban===undefined){
      setRoleFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#isDisabled':true,
          '#required':false,
        },
        'ulb','block','ward', 'village','gram_panchayat')));
      setfieldFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#isDisabled':true,
          '#required':false,
        },
        'ulb','block','ward', 'village','gram_panchayat')));
      setfacilityFormData((roleDetails: any) => (
        setIsFieldDisabledOrRequired(roleDetails, {
          '#isDisabled':true,
          '#required':false,
        },
        'ulb','block','ward', 'village','gram_panchayat')));
        setRoleFormState((roleState: any) => (
          setIsFieldDisabledOrRequired(roleState, {
            'value':'',
            'id':'',
            'code':'',
            'message':'',
            'isError':false,
          },
          'ulb','block','ward', 'village','gram_panchayat')));
      setFormStateForFacility((roleState: any) => (
        setIsFieldDisabledOrRequired(roleState, {
          'value':'',
          'id':'',
          'code':'',
          'message':'',
          'isError':false,
        },
        'ulb','block','ward', 'village','gram_panchayat')));
        setFormStateForField((roleState: any) => (
        setIsFieldDisabledOrRequired(roleState, {
          'value':'',
          'id':'',
          'code':'',
          'message':'',
          'isError':false,
        },
        'ulb','block','ward', 'village','gram_panchayat')));

    }
  },[ruralUrban, hasBlocksForDistrict])

  const getVillageByFacility=async ()=>{
    const facilityID= formState1?.user_type?.value==='Facility Level User'?formStateForFacility?.health_facility_name?.id:formStateForField?.health_facility_name?.id;
    if(facilityID){
      const village = await getData<any[]>(`${endpoints.getVillageByFacilityId(facilityID)}`);
      const villageOptions = village.data.map((option1: any) => ({
        value: option1.village_name,
        label: option1.village_name,
        id: option1.village_id,
        code: option1.village_code,
      }));
  
    if(formState1.user_type.value==='Facility Level User'){
      setfacilityFormData((role_details:any) => ({
        ...role_details,
        village: {
          ...role_details.village,
          '#options': villageOptions,
          '#required': villageOptions.length && role_details.village['#isDisabled'] === false ? true :false,
        },
        ward:{
          ...role_details.ward,
          '#required': role_details.ward['#isDisabled'] === true ? false : true
        }
  
      }))
      setFormStateForFacility((roleFormState:any) => ({
        ...roleFormState,
        village: {
          ...roleFormState.village,
          value: roleFormState.village.value,
          id: roleFormState.village.id
        },
      }))
    }
    else{
      setfieldFormData((role_details:any) => ({
        ...role_details,
        village: {
          ...role_details.village,
          '#options': villageOptions,
          '#required': villageOptions.length && role_details.village['#isDisabled'] === false ? true :false,
        },
        ward:{
          ...role_details.ward,
          '#required': role_details.ward['#isDisabled'] === true ? false : true
        }
      }))
      setFormStateForField((roleFormState:any) => ({
        ...roleFormState,
        village: {
          ...roleFormState.village,
          value: roleFormState.village.value,
          id: roleFormState.village.id
        },
      }))
    }
    }
  }

  const getGramPanchayatByFacility=async ()=>{
    const facilityID= formState1?.user_type?.value==='Facility Level User'?formStateForFacility?.health_facility_name?.id:formStateForField?.health_facility_name?.id;
    if(facilityID){
      const gramPanchayat = await getData<any[]>(`${endpoints.getGramPanchayatCoverageByFacilityId(facilityID)}`);
      const gramPanchayatOptions = gramPanchayat.data.map((option1: any) => ({
        value: option1.gram_panchayat_name,
        label: option1.gram_panchayat_name,
        id: option1.gram_panchayat_id,
        code: option1.gram_panchayat_code,
      }));
  
    if(formState1.user_type.value==='Facility Level User'){
      setfacilityFormData((role_details:any) => ({
        ...role_details,
        gram_panchayat: {
          ...role_details.gram_panchayat,
          '#options': gramPanchayatOptions,
          '#required': gramPanchayatOptions.length && role_details.gram_panchayat['#isDisabled'] === false ? true :false,
        },
  
      }))
      setFormStateForFacility((roleFormState:any) => ({
        ...roleFormState,
        gram_panchayat: {
          ...roleFormState.gram_panchayat,
          value: roleFormState.gram_panchayat.value,
          id: roleFormState.gram_panchayat.id
        },
      }))
    }
    else{
      setfieldFormData((role_details:any) => ({
        ...role_details,
        gram_panchayat: {
          ...role_details.gram_panchayat,
          '#options': gramPanchayatOptions,
          '#required': gramPanchayatOptions.length && role_details.gram_panchayat['#isDisabled'] === false ? true :false,
        },
  
      }))
      setFormStateForField((roleFormState:any) => ({
        ...roleFormState,
        gram_panchayat: {
          ...roleFormState.gram_panchayat,
          value: roleFormState.gram_panchayat.value,
          id: roleFormState.gram_panchayat.id
        },
      }))
    }
    }
  }

  const getWardByFacility=async ()=>{
    const facilityID = formState1?.user_type?.value==='Facility Level User'?formStateForFacility?.health_facility_name?.id:formStateForField?.health_facility_name?.id;
    if (facilityID)
      {
        const ward = await getData<any[]>(`${endpoints.getWardByFacilityId(facilityID)}`);
        const wardOptions = ward.data.map((key: any) => ({
        value: key.ward_name,
        label: key.ward_name,
        id: key.ward_id,
        code: key.ward_code
      }));
    
    if(formState1.user_type.value==='Facility Level User'){
      setFormStateForFacility((roleFormState:any) => ({
        ...roleFormState,
        ward: {
          ...roleFormState.ward,
          value: '',
          id:[],
          code:[]
        },
      }))
      setfacilityFormData((role_details:any) => ({
        ...role_details,
        ward: {
          ...role_details.ward,
          '#options': [],
        },
      }))
      setfacilityFormData((role_details:any) => ({
        ...role_details,
        ward: {
          ...role_details.ward,
          '#options': wardOptions,
          '#required': wardOptions.length && role_details.ward['#isDisabled'] === false ? true :false,
        },
        village:{
          ...role_details.village,
          '#required': role_details.village['#isDisabled'] === false ? true :false,
        }
      }))
      setFormStateForFacility((roleFormState:any) => ({
        ...roleFormState,
        ward: {
          ...roleFormState.ward,
          value: roleFormState.ward.value,
          id: roleFormState.ward.id
        },
      }))
    }
    else{
      setFormStateForField((roleFormState:any) => ({
        ...roleFormState,
        ward: {
          ...roleFormState.ward,
          value: '',
          id: [],
          code:[]
        },
      }))
      setfieldFormData((role_details:any) => ({
        ...role_details,
        ward: {
          ...role_details.ward,
          '#options': [],
        }
      }))
     
      setfieldFormData((role_details:any) => ({
        ...role_details,
        ward: {
          ...role_details.ward,
          '#options': wardOptions,
          '#required': wardOptions.length && role_details.ward['#isDisabled'] === false ? true :false,
        },
        village:{
          ...role_details.village,
          '#required': role_details.village['#isDisabled'] === false ? true :false,
        }
      }))
      setFormStateForField((roleFormState:any) => ({
        ...roleFormState,
        ward: {
          ...roleFormState.ward,
          value: roleFormState.ward.value,
          id: roleFormState.ward.id
        },
      }))
    }
  }
  }

  useEffect(()=>{
    try{
      if((formStateForFacility.health_facility_name.value!=='' && formStateForFacility.health_facility_name.value!==undefined )
      ||(formStateForField.health_facility_name.value!=='' && formStateForField.health_facility_name.value!==undefined)){
    if(ruralUrban==='Rural'){
      isGrampanchayat? getGramPanchayatByFacility() : getVillageByFacility();
    }
    else{
      getWardByFacility();
    }
  }
  else{
    setFormStateForFacility((roleFormState:any) => ({
      ...roleFormState,
      village: {
        ...roleFormState.village,
        value: '',
        id:[],
        code:[]
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id:[],
        code:[]
      },
      ward: {
        ...roleFormState.ward,
        value: '',
        id: ''
      },
    }))
    setfacilityFormData((role_details:any) => ({
      ...role_details,
      village: {
        ...role_details.village,
        '#options': [],
      },
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': [],
      },
      ward: {
        ...role_details.ward,
        '#options': [],
      },
    }))
    setFormStateForField((roleFormState:any) => ({
      ...roleFormState,
      village: {
        ...roleFormState.village,
        value: '',
        id: [],
        code:[]
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: [],
        code:[]
      },
      ward: {
        ...roleFormState.ward,
        value: '',
        id: [],
        code:[]
      },
    }))
    setfieldFormData((role_details:any) => ({
      ...role_details,
      village: {
        ...role_details.village,
        '#options': [],
      },
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': [],
      },
      ward: {
        ...role_details.ward,
        '#options': [],
      },

    }))
  }
  
  }
  catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  },[formStateForFacility.health_facility_name.value,formStateForField.health_facility_name.value])



  //Role details API's assiging 
  //Getting Role and State
  useEffect(()=>{
      //resetting the first name and last name enabling and hfr/abha not verified when usertype chnages
    setUserData((user_details:any) => ({
      ...user_details,
      fName:{
        ...user_details.fName,
        '#required': true,
        '#isDisabled':false,

      },
      lName:{
        ...user_details.lName,
        '#isDisabled':false,
        '#required': true,
      },
    }))
    dispatch(updateForm("isVerified",'false'));
    if(formState1.user_type.id && formState1.designation.id)
      {
        getRoles(formState1.user_type.id, formState1.designation.id);
      }
  },[formState1.user_type.id,formState1.designation.id]);
  useEffect(()=>{
    (async () => {
     
      await getRuralOrUrban();
      getStates();
    })();
  },[]);
  
  useEffect(()=>{
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      zone_div_circle: { ...roleFormState.zone_div_circle, value: '', id: '' },
      district: { ...roleFormState.district, value: '', id: '' },
      sub_district: { ...roleFormState.sub_district, value: '', id: '' },
      health_block: { ...roleFormState.health_block, value: '', id: '' },
      sub_division: { ...roleFormState.health_block, value: '', id: '' },
      ulb: { ...roleFormState.ulb, value: '', id: '' },
      ward: { ...roleFormState.ward, value: '', id: '' },
      block: { ...roleFormState.block, value: '', id: '' },
      village: { ...roleFormState.village, value: '', id: '' },
      gram_panchayat: { ...roleFormState.gram_panchayat, value: '', id: '' },
    }))
    if(roleFormState.state.id)
      {
        checkIfUsingGramPanchayat();
        getULB(roleFormState.state.id);
        getZoneDicCircle(roleFormState.state.id);
        getDistrictForState(roleFormState.state.id);
      }
    else{
      setRoleFormData((role_details:any) => ({
        ...role_details,
        zone_div_circle: {
          ...role_details.zone_div_circle,
          '#options': [],
        },
        district: {
          ...role_details.district,
          '#options': [],
        },
        sub_district: {
          ...role_details.sub_district,
          '#options': [],
        },
        health_block: {
          ...role_details.health_block,
          '#options':[],
        },
        ward: {
          ...role_details.ward,
          '#options':[],
        },
        sub_division: {
          ...role_details.sub_division,
          '#options': [],
        },
        block: {
          ...role_details.block,
          '#options': [],
        },
        village: {
          ...role_details.village,
          '#options': [],
        },
        gram_panchayat: {
          ...role_details.gram_panchayat,
          '#options': [],
        },
      }))
    }
  },[roleFormState.state.id]);

  useEffect(()=>{
    if(roleFormState.zone_div_circle.id.length === 1 && roleFormData.zone_div_circle['#multiDropdown'] === false && hasZonesCreated){
      if(['Super Admin User', 'National Level User', 'State Level User'].includes(userTypeName)){
        getDistrictForZDC(roleFormState.zone_div_circle.id);
      }
    }
    else{
      getDistrictForState(roleFormState?.state?.id);
    }
    if(['Super Admin User', 'National Level User', 'State Level User'].includes(userTypeName)){
      setRoleFormState((roleFormState:any) => ({
        ...roleFormState,
      district: {
        ...roleFormState.district,
        value: '',
        id: '',
      }
      }))
    }
    else{
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      sub_district: {
        ...roleFormState.sub_district,
        value: '',
        id: '',
      },
      health_block: {
        ...roleFormState.health_block,
        value: '',
        id: '',
      },
      sub_division: {
        ...roleFormState.health_block,
        value: '',
        id: '',
      },
      block: {
        ...roleFormState.block,
        value: '',
        id: '',
      },
      village: {
        ...roleFormState.village,
        value: '',
        id: '',
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
      },
    }))
  }
    
  },[roleFormState.zone_div_circle.id])

  //getting sub Dist sub div block
  useEffect(() => {
    if (roleFormState.district.id) {
      getSubDistBlock(roleFormState.district.id);
      setRoleFormState((roleFormState: any) => ({
        ...roleFormState,
        sub_district: {
          ...roleFormState.sub_district,
          value: '',
          id: '',
        },
        health_block: {
          ...roleFormState.health_block,
          value: '',
          id: '',
        },
        sub_division: {
          ...roleFormState.health_block,
          value: '',
          id: '',
        },
        block: {
          ...roleFormState.block,
          value: '',
          id: '',
        },
        village: {
          ...roleFormState.village,
          value: '',
          id: '',
        },
        gram_panchayat: {
          ...roleFormState.gram_panchayat,
          value: '',
          id: '',
        },
      }));
    } else {
      setRoleFormState((roleFormState: any) => ({
        ...roleFormState,
        sub_district: {
          ...roleFormState.sub_district,
          value: '',
          id: '',
        },
        health_block: {
          ...roleFormState.health_block,
          value: '',
          id: '',
        },
        sub_division: {
          ...roleFormState.health_block,
          value: '',
          id: '',
        },
        block: {
          ...roleFormState.block,
          value: '',
          id: '',
        },
        village: {
          ...roleFormState.village,
          value: '',
          id: '',
        },
        gram_panchayat: {
          ...roleFormState.gram_panchayat,
          value: '',
          id: '',
        },
      }));
      setRoleFormData((roleFormData: any) => ({
        ...roleFormData,
        sub_district: {
          ...roleFormData.sub_district,
          '#options': [],
        },
        health_block: {
          ...roleFormData.health_block,
          '#options': [],
        },
        sub_division: {
          ...roleFormData.sub_division,
          '#options': [],
        },
        block: {
          ...roleFormData.block,
          '#options': [],
        },
        village: {
          ...roleFormData.village,
          '#options': [],
        },
        gram_panchayat: {
          ...roleFormData.gram_panchayat,
          '#options': [],
        }
      }))
    }
  }, [roleFormState.district.id]);

  //getting ward by ulb
  useEffect(()=>{
    if(roleFormState.ulb.id){
       getWard(roleFormState.ulb.id);
    }
    else{
      setRoleFormState((roleFormState: any) => ({
        ...roleFormState,
        ward: {
          ...roleFormState.ward,
          value: '',
          id: '',
        },
      }));
      setRoleFormData((roleFormData: any) => ({
        ...roleFormData,
        ward: {
          ...roleFormData.ward,
          '#options': [],
        }
      }))
    }
  },[roleFormState.ulb.id]);


  //getting village by Block and Sub-District
  useEffect(()=>{
    const fetchVillageOptions = async () => {
    // when the district has no blocks at all, sub-district selection alone should be enough to fetch villages
    const blockSatisfied = hasBlocksForDistrict === false ? true : !!roleFormState.block?.id;
    if(blockSatisfied && (roleFormData?.sub_district['#required'] == true ? roleFormState?.sub_district?.id : true)) {
      isGrampanchayat? getGramPanchayat(roleFormState.block.id) :getVillage(roleFormState.block.id);
    }
    else{
      setRoleFormData((role_details:any) => ({
        ...role_details,
        gram_panchayat: {
          ...role_details.gram_panchayat,
          '#options': [],
          '#required': false,
        },
        village: {
          ...role_details.village,
          '#options': [],
          '#required': false,
        },
      }))
      setRoleFormState((roleFormState:any) => ({
        ...roleFormState,
        gram_panchayat: {
          ...roleFormState.gram_panchayat,
          value: '',
          id: '',
        },
        village: {
          ...roleFormState.village,
          value: '',
          id: '',
        },
      }))
    }
    }
    fetchVillageOptions();
  },[roleFormState?.block?.id, roleFormState?.sub_district?.id, hasBlocksForDistrict]);

  useEffect(()=>{
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
     
      ulb: {
        ...roleFormState?.ulb,
        value: '',
        id: '',
      },
      ward: {
        ...roleFormState?.ward,
        value: '',
        id: '',
      },
      block: {
        ...roleFormState?.block,
        value: '',
        id: '',
      },
      village: {
        ...roleFormState?.village,
        value: '',
        id: '',
      },
      gram_panchayat: {
        ...roleFormState?.gram_panchayat,
        value: '',
        id: '',
      },
    }))
  },[roleFormState.rural_urban.id]);

  
  const getRuralOrUrban=async()=>{
    try {
    const roles = await getDataWithCache<any[]>(`${endpoints.getRuralUrbal}`)
    const ruralOrUrban_options = roles.data.map((key: any) => (
      {
        value: key?.urban_rural_name === 'rural' ? 'Rural' : 'Urban',
        label: key?.urban_rural_name === 'rural' ? 'Rural' : 'Urban',
        id: key?.urban_rural_id,
        code: key?.urban_rural_code ?? key?.urban_rural_id,
      }
    ));
    setRoleFormData((role_details:any) => ({
      ...role_details,
      rural_urban:{
        ...role_details.rural_urban,
        '#options': ruralOrUrban_options,
      },
    }))
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
     
      ulb: {
        ...roleFormState.ulb,
        value: '',
        id: '',
      },
      ward: {
        ...roleFormState.ward,
        value: '',
        id: '',
      },
      block: {
        ...roleFormState.block,
        value: '',
        id: '',
      },
      village: {
        ...roleFormState.village,
        value: '',
        id: '',
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
      },
    }))

    const loggedUrbanRuralName = loggedInUserDetails?.urban_rural_name?.toLowerCase();
    const loggedUrbanRuralMatch = ruralOrUrban_options.find((option: any) => {
      const optionValue = option.value?.toLowerCase();
      return optionValue === loggedUrbanRuralName || optionValue === `${loggedUrbanRuralName}`;
    });
    if (loggedUrbanRuralMatch) {
      const nextRuralUrbanValue = loggedUrbanRuralMatch.value;
      setRuralUrban(nextRuralUrbanValue);
      setRuralUrbanId(loggedUrbanRuralMatch.id);
      setRoleFormState((prevState: any) => ({
        ...prevState,
        rural_urban: {
          ...prevState.rural_urban,
          value: nextRuralUrbanValue,
          id: loggedUrbanRuralMatch.id,
          code: loggedUrbanRuralMatch.code ?? prevState.rural_urban?.code ?? '',
        },
      }));
    }
         
  }    catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }

  useEffect(() => {
    if (!loggedInUserDetails) return;

    const userStateId = loggedInUserDetails?.state_id;
    const userDistrictId = loggedInUserDetails?.district_id;
    const userBlockId = loggedInUserDetails?.block_id;
    const userVillageId = loggedInUserDetails?.village_id;
    const userWardId = loggedInUserDetails?.ward_id;
    const userUlbId = loggedInUserDetails?.ulb_id;

    if (!userStateId || !userDistrictId) return;
    if (String(roleFormState?.state?.id || '') !== String(userStateId)) return;
    if (String(roleFormState?.district?.id || '') !== String(userDistrictId)) return;

    const blockOptions = roleFormData?.block?.['#options'] || [];
    const villageOptions = roleFormData?.village?.['#options'] || [];
    const wardOptions = roleFormData?.ward?.['#options'] || [];
    const ulbOptions = roleFormData?.ulb?.['#options'] || [];

    if (isBlockLevelLogin && userBlockId && blockOptions.length && (!roleFormState.block?.value || String(roleFormState.block.id || '') !== String(userBlockId))) {
      const matchedBlock = findMatchedOption(blockOptions, userBlockId);
      if (matchedBlock) {
        setRoleFormState((prevState: any) => ({
          ...prevState,
          block: {
            ...prevState.block,
            value: matchedBlock.value,
            id: String(matchedBlock.id),
            code: matchedBlock.code ?? prevState.block?.code ?? '',
          },
        }));
      }
    }

    if (!isBlockLevelLogin && userVillageId && villageOptions.length && (!roleFormState.village?.value || String(roleFormState.village.id || '') !== String(userVillageId))) {
      const matchedVillage = findMatchedOption(villageOptions, userVillageId);
      if (matchedVillage) {
        setRoleFormState((prevState: any) => ({
          ...prevState,
          village: {
            ...prevState.village,
            value: matchedVillage.value,
            id: String(matchedVillage.id),
            code: matchedVillage.code ?? prevState.village?.code ?? '',
          },
        }));
      }
    }

    if (userWardId && wardOptions.length && (!roleFormState.ward?.value || String(roleFormState.ward.id || '') !== String(userWardId))) {
      const matchedWard = findMatchedOption(wardOptions, userWardId);
      if (matchedWard) {
        setRoleFormState((prevState: any) => ({
          ...prevState,
          ward: {
            ...prevState.ward,
            value: matchedWard.value,
            id: String(matchedWard.id),
            code: matchedWard.code ?? prevState.ward?.code ?? '',
          },
        }));
      }
    }

    if (userUlbId && ulbOptions.length && (!roleFormState.ulb?.value || String(roleFormState.ulb.id || '') !== String(userUlbId))) {
      const matchedUlb = findMatchedOption(ulbOptions, userUlbId);
      if (matchedUlb) {
        setRoleFormState((prevState: any) => ({
          ...prevState,
          ulb: {
            ...prevState.ulb,
            value: matchedUlb.value,
            id: String(matchedUlb.id),
            code: matchedUlb.code ?? prevState.ulb?.code ?? '',
          },
        }));
      }
    }
  }, [
    loggedInUserDetails,
    roleFormState?.state?.id,
    roleFormState?.district?.id,
    roleFormState?.block?.value,
    roleFormState?.block?.id,
    roleFormState?.village?.value,
    roleFormState?.village?.id,
    roleFormState?.ward?.value,
    roleFormState?.ward?.id,
    roleFormState?.ulb?.value,
    roleFormState?.ulb?.id,
    roleFormData?.block?.['#options'],
    roleFormData?.village?.['#options'],
    roleFormData?.ward?.['#options'],
    roleFormData?.ulb?.['#options'],
    hasBlocksForDistrict,
  ]);
  const getRoles =async(userTypeId:any, userDesignationId:any)=>{
    try{
    const roles = await getDataWithCache<any[]>(`${endpoints.getAllRoles(userTypeId,userDesignationId)}`)
    const rolesValue = roles.data && roles.data.map((value: any) => value.role_name);
    const rolesCode = roles.data && roles.data.map((value: any) => value.role_code);
    const rolesId = roles.data && roles.data.map((value: any) => value.role_id);
    const compositeRoleId = roles.data && roles.data.map((value: any) => value.composite_role_id);

    if(formState1.user_type.value==='Field Level User'){
      const rolesOptions = roles.data
  .filter((key: any) => key.role_name === 'Service Provider')
  .map((key: any) => ({
    value: key.role_name,
    label: key.role_name,
    id: key.role_id,
    code: key.role_code,
    compositeRoleId:key.composite_role_id
  }));
  setRoleFormData((role_details:any) => ({
    ...role_details,
    role_name:{
      ...role_details.role_name,
      '#options': rolesOptions,
    },
  }))
  setRoleFormState((roleFormState:any) => ({
    ...roleFormState,
    role_name:{
      ...roleFormState.role_name,
      value:roleFormState.role_name.value,
      id:roleFormState.role_name.id,
      code:roleFormState.role_name.code,
      compositeRoleId:roleFormState.role_name.compositeRoleId,
    },
  }))

    }
    else{
    const rolesOptions = roles.data.map((key: any) => ({
      value: key.role_name,
      label: key.role_name,
      id: key.role_id,
      code: key.role_code,
      compositeRoleId: key.composite_role_id
    }));
    setRoleFormData((role_details:any) => ({
      ...role_details,
      role_name:{
        ...role_details.role_name,
        '#options': rolesOptions,
      },
    }))
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      role_name:{
        ...roleFormState.role_name,
        value:roleFormState.role_name.value,
        id:roleFormState.role_name.id,
        code:roleFormState.role_name.code,
        compositeRoleId:roleFormState.role_name.compositeRoleId,
      },
    }))
  }
}     catch(error:any){
  errorLogger(error?.response?.data||error?.response||error)
}
  }
  const getStates=async ()=>{
    try{
    const states = await getDataWithCache<any[]>(`${endpoints.getStates}`);
    const stateOptions = states.data.map((key: any) => ({
      value: `${key.state_name}-${key.state_code}`,
      label: `${key.state_name}-${key.state_code}`,
      id: key.state_id,
      code:key.state_code
    }));
    setRoleFormData((role_details:any) => ({
      ...role_details,
      state:{
        ...role_details.state,
        '#options': stateOptions,
        '#isDisabled': states.data.length === 1 ? true : false,
      },
      zone_div_circle: {
        ...role_details.zone_div_circle,
        '#options': [],
      },
      district: {
        ...role_details.district,
        '#options': [],
      },
      sub_district: {
        ...role_details.sub_district,
        '#options': [],
      },
      health_block: {
        ...role_details.health_block,
        '#options':[],
      },
      ulb: {
        ...role_details.ulb,
        '#options': [],
      },
      ward: {
        ...role_details.ward,
        '#options':[],
      },
      sub_division: {
        ...role_details.sub_division,
        '#options': [],
      },
      block: {
        ...role_details.block,
        '#options': [],
      },
      village: {
        ...role_details.village,
        '#options': [],
      },
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': [],
      },
    }))
    const loggedInStateMatch = findMatchedOption(stateOptions, loggedInUserDetails?.state_id);
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      state:{
        ...roleFormState.state,
        value: states.data.length === 1 ? `${states.data[0].state_name}-${states.data[0].state_code}` : (loggedInStateMatch ? loggedInStateMatch.value : ''),
        id: states.data.length === 1 ? `${states.data[0].state_id}` : (loggedInStateMatch ? String(loggedInStateMatch.id) : ''),
        code: states.data.length === 1 ? states.data[0].state_code : (loggedInStateMatch ? loggedInStateMatch.code : null),
      },
      district: {
        ...roleFormState.district,
        value: '',
        id: '',
      },
      sub_district: {
        ...roleFormState.sub_district,
        value: '',
        id: '',
      },
      health_block: {
        ...roleFormState.health_block,
        value: '',
        id: '',
      },
      sub_division: {
        ...roleFormState.health_block,
        value: '',
        id: '',
      },
      ulb: {
        ...roleFormState.ulb,
        value: '',
        id: '',
      },
      ward: {
        ...roleFormState.ward,
        value: '',
        id: '',
      },
      block: {
        ...roleFormState.block,
        value: '',
        id: '',
      },
      village: {
        ...roleFormState.village,
        value: '',
        id: '',
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
      },
    }))
    if(states.data.length === 1){
      checkIfUsingGramPanchayat();
    }
  } catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
}
  }

  const getZoneDicCircle=async (stateId:any)=>{
    try{
    const ZoneDicCircles = await getData<any[]>(`${endpoints.getZoneDiVCircleByStateID}/${stateId}`);
    const ZDCOptions = ZoneDicCircles.data.map((key: any) => ({
      value: `${key.zone_div_circle_name}-${key.zone_div_circle_code}`,
      label: `${key.zone_div_circle_name}-${key.zone_div_circle_code}`,
      id: key.zone_div_circle_id,
      code: key.zone_div_circle_code
    }));
    ZDCOptions.length? setHasZonesCreated(true): setHasZonesCreated(false);

    setRoleFormData((role_details:any) => ({
      ...role_details,
      zone_div_circle: {
        ...role_details.zone_div_circle,
        '#options': ZDCOptions,
        '#required': (ZDCOptions.length && !role_details.zone_div_circle['#isDisabled']) ? true : false,
      },
    }));
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      zone_div_circle: {
        ...roleFormState.zone_div_circle,
        value: '',
        id: '',
      }
    }));
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }

  const getDistrictForState = async (stateId:any)=>{
    try{
    if(stateId){
      const districts = await getData<any[]>(`${endpoints.getDistricts(stateId)}`);
      setDistrictOptions(districts)
    }
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }

  const getDistrictForZDC = async (ZDCId:any)=>{
    try{
    if(ZDCId){
      const districts = await getData<any[]>(`${endpoints.getDistrictsByZDCId(ZDCId)}`);
      setDistrictOptions(districts)
    }
  }    catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }

  const setDistrictOptions=async (districts:any)=>{
    const distOptions = districts.data.map((key: any) => ({
      value: `${key.district_name}-${key.district_code}`,
      label: `${key.district_name}-${key.district_code}`,
      id: key.district_id,
      code: key.district_code
    }));
    const shouldDisableDistrict = ['Zone / Circle / Region / Division Level User', 'ULB Level User'].includes(formState1.user_type.value);
    setRoleFormData((role_details:any) => ({
      ...role_details,
      
      district: {
        ...role_details.district,
        '#options': distOptions,
        '#required':(['Super Admin User', 'National Level User', 'State Level User','Zone / Circle / Region / Division Level User', 'ULB Level User'].includes(formState1.user_type.value)) ? false : true,
        '#isDisabled': shouldDisableDistrict,
      },
      // sub_district: {
      //   ...role_details.sub_district,
      //   '#options': [],
      // },
      // health_block: {
      //   ...role_details.health_block,
      //   '#options':[],
      // },
      ward: {
        ...role_details.ward,
        '#options':[],
      },
      // sub_division: {
      //   ...role_details.sub_division,
      //   '#options': [],
      // },
      // block: {
      //   ...role_details.block,
      //   '#options': [],
      // },
      village: {
        ...role_details.village,
        '#options': [],
      },
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': [],
      },
    }))
    const loggedInDistrictMatch = findMatchedOption(distOptions, loggedInUserDetails?.district_id);
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      district: {
        ...roleFormState.district,
        value: ((!['Super Admin User','National Level User'].includes(userTypeName)) && (!['ULB Level User', 'Zone / Circle / Region / Division Level User'].includes(formState1.user_type.value))) ? (districts.data.length === 1 ? `${districts.data[0].district_name}-${districts.data[0].district_code}` : (loggedInDistrictMatch ? loggedInDistrictMatch.value : '')) : '',
        id: ((!['Super Admin User','National Level User'].includes(userTypeName) && (!['ULB Level User', 'Zone / Circle / Region / Division Level User'].includes(formState1.user_type.value)))) ? (districts.data.length === 1 ? `${districts.data[0].district_id}` : (loggedInDistrictMatch ? String(loggedInDistrictMatch.id) : '')) : '',
        code: ((!['Super Admin User','National Level User'].includes(userTypeName) && (!['ULB Level User', 'Zone / Circle / Region / Division Level User'].includes(formState1.user_type.value)))) ? (districts.data.length === 1 ? `${districts.data[0].district_code}` : (loggedInDistrictMatch ? loggedInDistrictMatch.code : '')) : '',
      },
      sub_district: {
        ...roleFormState.sub_district,
        value: '',
        id: '',
      },
      health_block: {
        ...roleFormState.health_block,
        value: '',
        id: '',
      },
      sub_division: {
        ...roleFormState.health_block,
        value: '',
        id: '',
      },
      ulb: {
        ...roleFormState.ulb,
        value: '',
        id: '',
      },
      ward: {
        ...roleFormState.ward,
        value: '',
        id: '',
      },
      block: {
        ...roleFormState.block,
        value: '',
        id: '',
      },
      village: {
        ...roleFormState.village,
        value: '',
        id: '',
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
      },
    }))
  }

  useEffect(() => {
    if (userTypeName === 'State Level User' && (roleFormData.district['#options'] || []).length > 0) {
      setRoleFormData((roleDetails: any) => ({
        ...roleDetails,
        district: {
          ...roleDetails.district,
          '#isDisabled': false,
        },
      }));
    }
  }, [userTypeName, roleFormData.district['#options']]);

  const fecthUlbBySearch = async (ulbInputText:string) => {
    const getUlbwithsearch = await axios.get(`${endpoints.fetchUlbByStateIdAndSearch(roleFormState?.state?.id, ulbInputText)}`,Auth.loggedIn());
    const getUlb_options = getUlbwithsearch?.data.data?.map((key: any) => ({
      value: `${key.ulb_name}-${key.ulb_code}`,
      label: `${key.ulb_name}-${key.ulb_code}`,
      id: key.ulb_id,
      code: key.ulb_code,
    }));
    setRoleFormData((hierarchy_details_urban: any) => ({
      ...hierarchy_details_urban,
      ulb: {
        ...hierarchy_details_urban.ulb,
        '#options': getUlb_options,
        '#required': true,
        '#isDisabled': false,
      },
    }));
  }

  useEffect(()=>{

    if(!loggedInUserDetails?.ulb_id && roleFormState?.state?.id && ulbInputText?.length >= 3){
      fecthUlbBySearch(ulbInputText)
    }
    if(ulbInputText?.length === 0)
      {
        setRoleFormData((hierarchy_details_urban: any) => ({
          ...hierarchy_details_urban,
          ulb: {
            ...hierarchy_details_urban.ulb,
            '#options': [],
          },
        }));
      }
  },[ulbInputText])

  const getULB=async (stateId:any)=>{
    try{
    // const ulb = await getData<any[]>(`${endpoints.getUlb}/${stateId}`);
    // const ulbOptions = ulb.data.map((key: any) => ({
    //   value: `${key.ulb_name}-${key.ulb_code}`,
    //   label: `${key.ulb_name}-${key.ulb_code}`,
    //   id: key.ulb_id,
    // }));
    const loggedUlb = loggedInUserDetails?.ulb_id ? {
      value: loggedInUserDetails?.ulb_name ? `${loggedInUserDetails.ulb_name}-${loggedInUserDetails.ulb_code}` : '',
      label: loggedInUserDetails?.ulb_name ? `${loggedInUserDetails.ulb_name}-${loggedInUserDetails.ulb_code}` : '',
      id: loggedInUserDetails.ulb_id,
      code: loggedInUserDetails.ulb_code,
    } : undefined;
    setRoleFormData((role_details:any) => ({
      ...role_details,
    
      ulb: {
        ...role_details.ulb,
        '#options': loggedUlb ? [loggedUlb] : (role_details.ulb['#options'] || []),
        '#isDisabled' : loggedUlb ? true : false,
        '#required': loggedUlb ? true : (role_details.ulb['#isDisabled'] === false ? true : false),
      },
      ward: {
        ...role_details.ward,
        '#options':[],
      },
      block: {
        ...role_details.block,
        '#options': [],
      },
      village: {
        ...role_details.village,
        '#options': [],
      },
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': [],
      },
    }))
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      ulb: loggedUlb ? {
        ...roleFormState.ulb,
        value: loggedUlb.value,
        id: String(loggedUlb.id),
        code: loggedUlb.code,
      } : {
        ...roleFormState.ulb,
        value: '',
        id: '',
      },
      ward: {
        ...roleFormState.ward,
        value: '',
        id: '',
      },
      block: {
        ...roleFormState.block,
        value: '',
        id: '',
      },
      village: {
        ...roleFormState.village,
        value: '',
        id: '',
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
      },
    }))
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }
  const handleInputChange=_.debounce((value:string, key:string)=>{
    if(key === 'ulb'){
      setUlbInputText(value.trim());
    }
  },500);
  
  const getSubDistBlock = async (districtId: any) => {
    try {
      const getSubDist = await getData<any[]>(`${endpoints.getSubDistricts(districtId)}`);
      const subDistOptions = getSubDist.data.map((option1: any) => ({
        value: `${option1.sub_district_name}-${option1.sub_district_code}`,
        label: `${option1.sub_district_name}-${option1.sub_district_code}`,
        id: option1.sub_district_id,
      }));
      const getHealthBlock = await getData<any[]>(`${endpoints.getHealthBlock(districtId)}`);
      const healthBlockOptions = getHealthBlock.data.map((option1: any) => ({
        value: `${option1.heal_block_name}-${option1.heal_block_code}`,
        label: `${option1.heal_block_name}-${option1.heal_block_code}`,
        id: option1.health_block_id,
      }));
      const subDivision = await getData<any[]>(`${endpoints.getSubDivision(districtId)}`);
      const subDivisionOptions = subDivision.data.map((option1: any) => ({
        value: `${option1.sub_division_name}-${option1.sub_division_code}`,
        label: `${option1.sub_division_name}-${option1.sub_division_code}`,
        id: option1.sub_division_id,
      }));
      const getBlock = await getData<any[]>(`${endpoints.getBlock(districtId)}`);
      const getBlockOptions = getBlock.data.map((option1: any) => ({
        value: `${option1.block_name}-${option1.block_code}`,
        label: `${option1.block_name}-${option1.block_code}`,
        id: option1.block_id,
      }));
      setHasBlocksForDistrict(getBlockOptions.length > 0);
      const shouldEnableBlockSelection = isBlockLevelLogin || [USER_TYPES.BLOCK_LEVEL_USER, USER_TYPES.FACILITY_LEVEL_USER, USER_TYPES.FIELD_LEVEL_USER].includes(formState1.user_type.value);
      const loggedInBlockMatch = isBlockLevelLogin ? findMatchedOption(getBlockOptions, loggedInUserDetails?.block_id) : undefined;
      const loggedInSubDistrictMatch = isBlockLevelLogin ? findMatchedOption(subDistOptions, loggedInUserDetails?.sub_district_id) : undefined;
      setRoleFormData((roleFormData: any) => ({
        ...roleFormData,
        sub_district: {
          ...roleFormData.sub_district,
          '#options': subDistOptions,
          '#required': (subDistOptions.length > 0 && !roleFormData.sub_district['#isDisabled']),
        },
        health_block: {
          ...roleFormData.health_block,
          '#options': healthBlockOptions,
          '#required': formState1.user_type.value === 'Health Block/ Sub Division Level User'? true : false,
        }, 
        sub_division: {
          ...roleFormData.sub_division,
          '#options': subDivisionOptions,
          '#required': formState1.user_type.value === 'Health Block/ Sub Division Level User'? true : false,
        },
      
        block: {
          ...roleFormData.block,
          '#options': getBlockOptions,
          '#isDisabled': getBlockOptions.length === 0 ? true : (shouldEnableBlockSelection ? false : true),
          '#required': getBlockOptions.length > 0 && shouldEnableBlockSelection,

        },
        village: {
          ...roleFormData.village,
          '#options': [],
        },
        gram_panchayat: {
          ...roleFormData.gram_panchayat,
          '#options': [],
        },
      }));
      if (loggedInBlockMatch) {
        setRoleFormState((prevState: any) => ({
          ...prevState,
          block: {
            ...prevState.block,
            value: loggedInBlockMatch.value,
            id: String(loggedInBlockMatch.id),
            code: loggedInBlockMatch.code ?? prevState.block?.code ?? '',
          },
        }));
      }
      setRoleFormState((roleFormState: any) => ({
        ...roleFormState,
        sub_district: {
          ...roleFormState.sub_district,
          value: roleFormState.sub_district.value || (loggedInSubDistrictMatch ? loggedInSubDistrictMatch.value : ''),
          id: roleFormState.sub_district.id || (loggedInSubDistrictMatch ? String(loggedInSubDistrictMatch.id) : ''),
          code: roleFormState.sub_district.code || (loggedInSubDistrictMatch ? loggedInSubDistrictMatch.code : ''),
        },
        health_block: {
          ...roleFormState.health_block,
          value: roleFormState.health_block.value || (loggedInUserDetails?.health_block_id ? findMatchedOption(healthBlockOptions, loggedInUserDetails?.health_block_id)?.value || '' : ''),
          id: roleFormState.health_block.id || (loggedInUserDetails?.health_block_id ? String(findMatchedOption(healthBlockOptions, loggedInUserDetails?.health_block_id)?.id || '') : ''),
          code: roleFormState.health_block.code || (loggedInUserDetails?.health_block_id ? findMatchedOption(healthBlockOptions, loggedInUserDetails?.health_block_id)?.code || '' : ''),
        },
        sub_division: {
          ...roleFormState.sub_division,
          value: roleFormState.sub_division.value || (loggedInUserDetails?.sub_division_id ? findMatchedOption(subDivisionOptions, loggedInUserDetails?.sub_division_id)?.value || '' : ''),
          id: roleFormState.sub_division.id || (loggedInUserDetails?.sub_division_id ? String(findMatchedOption(subDivisionOptions, loggedInUserDetails?.sub_division_id)?.id || '') : ''),
          code: roleFormState.sub_division.code || (loggedInUserDetails?.sub_division_id ? findMatchedOption(subDivisionOptions, loggedInUserDetails?.sub_division_id)?.code || '' : ''),
        },
        block: {
          ...roleFormState.block,
          value: roleFormState.block.value || (loggedInBlockMatch ? loggedInBlockMatch.value : ''),
          id: roleFormState.block.id || (loggedInBlockMatch ? String(loggedInBlockMatch.id) : ''),
          code: roleFormState.block.code || (loggedInBlockMatch ? loggedInBlockMatch.code : ''),
        },
        gram_panchayat: {
          ...roleFormState.gram_panchayat,
          value: '',
          id: '',
        },
      }))
     
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }

    useEffect(() => {
      if (!isBlockLevelLogin) return;

      setRoleFormData((roleDetails: any) => ({
        ...roleDetails,
        block: {
          ...roleDetails.block,
          '#isDisabled': false,
        },
        village: {
          ...roleDetails.village,
          '#isDisabled': false,
        },
      }));
    }, [isBlockLevelLogin, roleFormData.block?.['#isDisabled'], roleFormData.village?.['#isDisabled']]);

  const getWard=async (ulbId:any)=>{
    try{
    const ward = await getData<any[]>(`${endpoints.getWard(ulbId)}`);
   
    const wardOptions = ward.data.map((key: any) => ({
      value: `${roleFormState.ulb.value}-${key.ward_name}-${key.ward_code}`,
      label: `${roleFormState.ulb.value}-${key.ward_name}-${key.ward_code}`,
      id: key.ward_id,
      code: key.ward_code
    }));
    const loggedInWardMatch = findMatchedOption(wardOptions, loggedInUserDetails?.ward_id);
    setRoleFormData((role_details:any) => ({
      ...role_details,
      ward: {
        ...role_details.ward,
        '#options': wardOptions,
        '#isDisabled': loggedInWardMatch ? true : role_details.ward['#isDisabled'],
        '#required': (wardOptions.length && role_details.ward['#isDisabled'] === false) ? true : false,
      },
    }))
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      ward: {
        ...roleFormState.ward,
        value: loggedInWardMatch ? loggedInWardMatch.value : (roleFormState.ward.value || ''),
        id: loggedInWardMatch ? String(loggedInWardMatch.id) : (roleFormState.ward.id || ''),
        code: loggedInWardMatch ? loggedInWardMatch.code : (roleFormState.ward.code || ''),
      },
    }))
  }    catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }
  const getVillage=async (blockId:any)=>{
    try{
      const postData = {
        p_state_id: roleFormState?.state?.id,
        p_dist_id: roleFormState?.district?.id,
        p_sub_dist_ids: roleFormState?.sub_district?.id ? [roleFormState?.sub_district?.id] : [],
        p_block_ids: blockId ? [blockId] : [],
        p_hbsd_ids: [],
      }
    const village = await axios.post(`${endpoints.getVillagesByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
    const villageOptions = village.data?.data?.map((option1: any) => ({
      value: `${option1.village_name}-${option1.village_code}`,
      label: `${option1.village_name}-${option1.village_code}`,
      id: option1.village_id,
      code: option1.village_code,
    }));
    const loggedInVillageMatch = findMatchedOption(villageOptions, loggedInUserDetails?.village_id);
    setRoleFormData((role_details:any) => ({
      ...role_details,

      village: {
        ...role_details.village,
        '#options': villageOptions,
        '#isDisabled': isBlockLevelLogin ? false : (loggedInVillageMatch ? true : role_details.village['#isDisabled']),
        '#required': isBlockLevelLogin ? (village?.data?.meta?.numberOfRecords > 0 ? true : false) : (loggedInVillageMatch ? true : (village?.data?.meta?.numberOfRecords > 0 ? true : false)),

      },

    }))
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      village: {
        ...roleFormState.village,
        value: loggedInVillageMatch ? loggedInVillageMatch.value : (roleFormState.village.value || ''),
        id: loggedInVillageMatch ? String(loggedInVillageMatch.id) : (roleFormState.village.id || ''),
        code: loggedInVillageMatch ? loggedInVillageMatch.code : (roleFormState.village.code || ''),
      },
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
      },
      }))
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }
  const getGramPanchayat=async (blockId:any)=>{
    try{
    const gramPanchayat = await getData<any[]>(`${endpoints.getGramPanchayatByBlockId(blockId)}`);
    const gramPanchayatOptions = gramPanchayat.data.map((option1: any) => ({
      value: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
      label: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
      id: option1.gram_panchayat_id,
    }));
    setRoleFormData((role_details:any) => ({
      ...role_details,
      gram_panchayat: {
        ...role_details.gram_panchayat,
        '#options': gramPanchayatOptions,
        '#required': (gramPanchayatOptions.length && roleFormData.gram_panchayat['#isDisabled'] === false) ? true : false,
      },

    }))
    setRoleFormState((roleFormState:any) => ({
      ...roleFormState,
      gram_panchayat: {
        ...roleFormState.gram_panchayat,
        value: '',
        id: '',
      },
    }))
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
 }
  }
  //Get Facility Types
  useEffect(()=>{
   getFacilityType();
  },[])
  useEffect(()=>{
    if(clearHpr){
      setFormState1((formState1: any) => ({
        ...formState1,
        hpr_id:{
          ...formState1.hpr_id,
          value:''
        }
      }));
      dispatch(updateForm("hprNumberCheck",false));
      dispatch(updateForm("ishprEntered",false));
      dispatch(updateForm("isOkButtonClicked",true))
    }
  },[clearHpr])

  const handleOK=async()=>{
    dispatch(updateForm("isNotVerified",false));
    if(hprNullCheck){
        dispatch(updateForm("isOkButtonClicked",true))
    }
    if(hprNumberCheck){
        dispatch(updateForm("ishprEntered",true));
        dispatch(updateForm("clearHpr",true));
    }
    dispatch(updateForm("hfrAbha", ''));
    setAlertModalOpen(false)
  }


  const getFacilityType=async ()=>{
    try{
    const facilityType = await getDataWithCache<any[]>(`${endpoints.getFacilityType}`);
    const facilityTypeOptions = facilityType.data.map((key: any) => ({
      value: key.facility_type,
      label: key.facility_type,
      id: key.facility_type_id,
      code:key.facility_type_code,
    }));
    setIntialFacilityTypes({facilityTypeOptions});
    setfacilityFormData((facilityFormData:any) => ({
      ...facilityFormData,
      health_facility_type: {
        ...facilityFormData.health_facility_type,
        '#options': facilityTypeOptions,
      },
      health_provider_tagged: {
        ...fieldFormData.health_provider_tagged,
        '#options': [],
      },
      mobiliser_tagged: {
        ...fieldFormData.mobiliser_tagged,
        '#options': [],
      },
    }));
    setfieldFormData((fieldFormData:any) => ({
      ...fieldFormData,
      health_facility_type: {
        ...fieldFormData.health_facility_type,
        '#options': facilityTypeOptions,
      },
      health_provider_tagged: {
        ...fieldFormData.health_provider_tagged,
        '#options': [],
      },
      mobiliser_tagged: {
        ...fieldFormData.mobiliser_tagged,
        '#options': [],
      },
    }))
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }
  // Get Facility Based on Village 
  useEffect(()=>{
    if(roleFormState?.village?.id){
      // getFacilityByVillage(roleFormState?.village?.id);
      isLoggedInUserANM()?getFacilityByLoggedInUser(): getFacilityByVillage(roleFormState?.village?.id);
      setFacilityLocationId(roleFormState.village.id);
      setFacilityLocationType(LocationType.Village);
    }
      
  },[roleFormState?.village?.id])

  useEffect(()=>{
    if(roleFormState?.gram_panchayat?.id){
      isLoggedInUserANM()?getFacilityByLoggedInUser():getFacilityByGramPanchayat(roleFormState?.gram_panchayat?.id);
      setFacilityLocationId(roleFormState.gram_panchayat.id);
      setFacilityLocationType(LocationType.GP);
    }
      
  },[roleFormState?.gram_panchayat?.id])

  const getFacilityByVillage=async (Id:any)=>{
    try{
    const params ={
      p_village_id:Id,
      p_facilitytype_id:'',
      p_search_facility:'' 
}
    const facility = await getDataParams<any[]>(`${endpoints.getFacilityByVillage}`,params);
    const facilityOptions = facility.data.map((key: any) => ({
      value: key.facility_name,
      label: key.facility_name,
      id: key.facilit_id,
      code:key.facility_code,
      fac_type_id:key.facility_type_id,
      hfr_id:key.hfr_id
    }));
    setInitialFacilityNames({facilityOptions})
    setfacilityFormData((facilityFormData:any) => ({
      ...facilityFormData,
      health_facility_name: {
        ...facilityFormData.health_facility_name,
        '#options': facilityOptions,
      },
    }));
    setfieldFormData((fieldFormData:any) => ({
      ...fieldFormData,
      health_facility_name: {
        ...fieldFormData.health_facility_name,
        '#options': facilityOptions,
      },
    }));
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }

  }
   
  const isLoggedInUserANM = () => {
    const designationName = loggedInUserDetails?.user_designation_name;
    return designationName === UserDesignation.anm;
  }
  const getfacilitytypename = (facility_type_id: any) => {
    let result = ''
    intialFacilityTypes.facilityTypeOptions.map((item: any) => {
      if (item.id === facility_type_id) {
        result = item.value;
      }
    }
    )
    return result
  }
  const getFacilityByLoggedInUser=async ()=>{
    try{
    const facility_details_response = await getData<any>(`${endpoints.getLinkedFacilitiesByUserById}/${LoggedInUserId}`);
    const facilityOptions = facility_details_response.data[0].map((key: any) => ({
      value: key.facility_name,
      label: key.facility_name,
      id: key.facility_id,
      code:key.facility_code,
      fac_type_id:key.facility_type_id,
      facilitytypename:getfacilitytypename(key.facility_type_id),
      hfr_id:key.hfr_id
    }));    
    setInitialFacilityNames({facilityOptions})
    setfacilityFormData((facilityFormData:any) => ({
      ...facilityFormData,
      health_facility_name: {
        ...facilityFormData.health_facility_name,
        '#options': facilityOptions,
      },
    }));
    setfieldFormData((fieldFormData:any) => ({
      ...fieldFormData,
      health_facility_name: {
        ...fieldFormData.health_facility_name,
        '#options': facilityOptions,
      },
    }));
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }

  }  
  const getFacilityByGramPanchayat=async (Id:any)=>{
    try{
    const params ={
      p_gram_panchayat_id:Id,
      p_facilitytype_id:'',
      p_search_facility:'' 
}
    const facility = await getDataParams<any[]>(`${endpoints.getFacilityByGramPanchayat}`,params);
    const facilityOptions = facility.data.map((key: any) => ({
      value: key.facility_name,
      label: key.facility_name,
      id: key.facilit_id,
      code:key.facility_code,
      fac_type_id:key.facility_type_id,
      hfr_id:key.hfr_id
    }));
    setInitialFacilityNames({facilityOptions})
    setfacilityFormData((facilityFormData:any) => ({
      ...facilityFormData,
      health_facility_name: {
        ...facilityFormData.health_facility_name,
        '#options': facilityOptions,
      },
    }));
    setfieldFormData((fieldFormData:any) => ({
      ...fieldFormData,
      health_facility_name: {
        ...fieldFormData.health_facility_name,
        '#options': facilityOptions,
      },
    }));
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
 }

  }

   // Get Facility Based on Ward 
  useEffect(()=>{
    if(roleFormState.ward.id){
      isLoggedInUserANM()?getFacilityByLoggedInUser():getFacilityByWard(roleFormState.ward.id);
      setFacilityLocationId(roleFormState.ward.id);
      setFacilityLocationType(LocationType.Ward);
    }
  },[roleFormState.ward.id])

  const getFacilityByWard=async (Id:any)=>{
    try{
    const params ={
                p_ward_id:Id,
                p_facilitytype_id:'',
                p_search_facility:'' 
    }
    const facility = await getDataParams<any[]>(`${endpoints.getFacilityByWard}`,params);
    const facilityOptions = facility.data.map((key: any) => ({
      value: key.facility_name,
      label: key.facility_name,
      id: key.facilit_id,
      code:key.facility_code,
      fac_type_id:key.facility_type_id,
      hfr_id:key.hfr_id
    }));
    setInitialFacilityNames({facilityOptions});
    setfacilityFormData((facilityFormData:any) => ({
      ...facilityFormData,
      health_facility_name: {
        ...facilityFormData.health_facility_name,
        '#options': facilityOptions,
      },
    }));

    setfieldFormData((fieldFormData:any) => ({
      ...fieldFormData,
      health_facility_name: {
        ...fieldFormData.health_facility_name,
        '#options': facilityOptions,
      },
    }));
  }     catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }

  const verify = {
    hprId: verifyHfr,
    abhaId: verifyAbha
  }

  // 


  const contents = [
    <div key="user details">
      <UserPage1 handleFormChange1={handleFormChange1} 
      formState1={formState1}
       formData={userData} />
    </div>,
    <div key="Role Details">
      <UserPage2 
      forceDistrictEnabled={userTypeName === 'State Level User'}
      
      handleFormChange2={(value: any, key: string, id: any, option: any, code: any, compositeRoleId:any) => {
        if (key === 'role_name' || key === 'zone_div_circle') {
          id = [];
          option?.length > 0 && value?.length > 0 && option?.forEach((op: any) => {
            if (value?.includes(op?.value)) {
              id.push(op?.id);
            }
          });
          code = [];
          option?.length > 0 && value?.length > 0 && option?.forEach((op: any) => {
            if (value?.includes(op?.value)) {
              code.push(op?.code);
            }
          });
          if(key === 'role_name'){
            compositeRoleId = [];
            option?.length > 0 && value?.length > 0 && option?.forEach((op: any) => {
            if (value?.includes(op?.value)) {
              compositeRoleId.push(op?.compositeRoleId);
            }
          });
          }
        }
       
        handleFormChange2(value, key,option, id, code, compositeRoleId);
      }}

      formState2={roleFormState}
      formData={roleFormData}
      onInputChange={handleInputChange}
       />
    </div>,
    <div key="Facility Details">
      <UserPage3  
      handleFormChange3={(value: any, key: string, id: any, option: any, code: any) => {
        if (key === 'ward' || key==='village' || key==='gram_panchayat'||key==='health_provider_tagged'||key==="mobiliser_tagged") {
          id = [];
          option.length > 0 && value.length > 0 && option.forEach((op: any) => {
            if (value.includes(op.value)) {
              id.push(op.id);
            }
          });
          code = [];
          option.length > 0 && value.length > 0 && option.forEach((op: any) => {
            if (value.includes(op.value)) {
              code.push(op.code);
            }
          });
        }
       
        handleFormChange3(value, key,id,option, code);
      }}
     // handleFormChange3={handleFormChange3}
      hfrVerifyFormData={hfrVerifyFormData}
      formState3={formState1.user_type.value==='Facility Level User'?formStateForFacility:formStateForField} 
      verify={verify} 
      formData={formState1.user_type.value==='Facility Level User'?facilityFormData:fieldFormData}
      facilityLocationId={facilityLocationId}
      facilityLocationType = {facilityLocationType}
      healthFacilityNames={initialFacilityNames}
      />
    </div>,
  ];
  
  const checkEmailAlreadyExists=async (emailId:string)=>{
    try{
      const payload={
        "emailId":emailId
      }
      const encodedPayload = encodeWithKeyAndShift(JSON.stringify(payload));
      const response = await postDataJSON<any>(`${endpoints.checkEmailAlreadyExists}`, {data:encodedPayload});
      const decodedData = JSON.parse(decodeWithKeyAndShift(response?.data?.data));
      return decodedData[0]?.check_email_exists
  }
  catch(error:any){
    return false;
  }
  }
  const handleSave = async (activeIndex: number): Promise<void> => {
    try{
    const errors: boolean[] = [];
    if (activeIndex === 0) {
      const formStateTemp1 = {
        ...formState1
      };
      let isFormError = false;
      const validationPromises = Object.keys(formStateTemp1).map(async (item) => {
        if (item === 'fName') {
          if (!formStateTemp1.fName.value.trim()) {
            isFormError = true;
            formStateTemp1.fName.isError = true;
            formStateTemp1.fName.message = 'First name cannot be kept blank. Enter a valid first name.';
          }
          else if (!/^[A-Za-z]+(?:[.\s]+[A-Za-z]+)*\.?$/.test(formStateTemp1.fName.value)) {
            isFormError = true;
            formStateTemp1.fName.isError = true;
            formStateTemp1.fName.message = 'Entered first name is invalid. Only alphabets,spaces and dot(.) are allowed.';
          }
          else if (formStateTemp1.fName.value.length > 100) {
            isFormError = true;
            formStateTemp1.fName.isError = true;
            formStateTemp1.fName.message = 'Entered first name length is invalid. Max 100 characters are allowed.';
          }
          else {
            formStateTemp1.fName.isError = false;
          }
        }
        
        else if (item === 'lName') {
          if (!formStateTemp1.lName.value.trim()) {
            isFormError = true;
            formStateTemp1.lName.isError = true;
            formStateTemp1.lName.message = 'Last name cannot be kept blank. Enter a valid last name.';
          }
          else if (!/^[a-zA-Z\s]+$/.test(formStateTemp1.lName.value)) {
            isFormError = true;
            formStateTemp1.lName.isError = true;
            formStateTemp1.lName.message = 'Entered last name is invalid. Number & Special characters are not allowed.';
          }
          else if (formStateTemp1.lName.value.length > 100) {
            isFormError = true;
            formStateTemp1.lName.isError = true;
            formStateTemp1.lName.message = 'Entered last name length is invalid. Max 100 characters are allowed.';
          }
          else {
            formStateTemp1.lName.isError = false;
          }
        }
        else if (item === 'mob') {
          if (!formStateTemp1.mob.value.length) {
            isFormError = true;
            formStateTemp1.mob.isError = true;
            formStateTemp1.mob.message = 'Phone number cannot be left blank. Please enter a valid phone number.';
          }
          else if (formStateTemp1.mob.value.length!== 10 ) {
            isFormError = true;
            formStateTemp1.mob.isError = true;
            formStateTemp1.mob.message = 'Invalid Entry. Enter 10 digits valid Phone Number.';
          }
          else if (formStateTemp1.mob.value.startsWith('0') ||
          formStateTemp1.mob.value.startsWith('+91')) {
            isFormError = true;
            formStateTemp1.mob.isError = true;
            formStateTemp1.mob.message = 'Invalid Entry. Enter 10 digits valid Phone Number.';
          }
          else {
            const data = { userName: formStateTemp1?.mob?.value };
            const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data)) ;     
            const response = await axios.post(`${endpoints.checkMobileNumberExists}`,{data:encodedPayload},Auth.loggedInWithJSON);
            const decodedResponse= JSON.parse(decodeWithKeyAndShift(response?.data?.data?.data));
            if(decodedResponse?.data[0]?.exists_flag === true)
              {
                isFormError = true;
                formStateTemp1.mob.isError = true;
                formStateTemp1.mob.message = 'Mobile number already registered with a different user.';                   
              }
              else{
                formStateTemp1.mob.isError = false;
              }
          }
        }
        else if (item === 'a_mob') {
          if(formStateTemp1.a_mob.value){
            if (formStateTemp1.a_mob.value.length!== 10) {
              formStateTemp1.a_mob.isError = true;
              formStateTemp1.a_mob.message = 'Invalid Entry. Enter 10 digits valid Phone Number.';
            }
            else if (formStateTemp1.a_mob.value.startsWith('0') ||
            formStateTemp1.a_mob.value.startsWith('+91')) {
            isFormError = true;
            formStateTemp1.a_mob.isError = true;
            formStateTemp1.a_mob.message = 'Invalid Entry. Enter 10 digits valid Phone Number.';
          }
            else {
              formStateTemp1.a_mob.isError = false;
            }
          }
        }
        else if (item === 'email') {
         // const regex = /^\S+@\S+\.\S+$/;
          if (formStateTemp1.email.value && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formStateTemp1.email.value)) {
            formStateTemp1.email.isError = true;
            isFormError = true;
            formStateTemp1.email.message = 'Enter correct Email format to continue.';
          }
          else if (formStateTemp1.email.value.trim()) {
            const emailExists=await checkEmailAlreadyExists(formStateTemp1.email.value.trim());
            if(emailExists){
              formStateTemp1.email.isError = true;
              isFormError = true;
              formStateTemp1.email.message = 'Email already registered with a different user.';
            }
          }
          else {
            formStateTemp1.email.isError = false;
          }
        }
        else if (item === 'user_type') {
          if (!formStateTemp1.user_type.value) {
            isFormError = true;
            formStateTemp1.user_type.isError = true;
            formStateTemp1.user_type.message = 'User Type cannot be kept blank. Select an user type from Dropdown.';
          }
          else {
            formStateTemp1.user_type.isError = false;
          }
        }
        else if (item === 'designation') {
          if (!formStateTemp1.designation.value) {
            isFormError = true;
            formStateTemp1.designation.isError = true;
            formStateTemp1.designation.message = 'Designation cannot be kept blank. Select an user designation from Dropdown.';
          }
          else {
            formStateTemp1.designation.isError = false;
          }
        }
        else if (item === 'doj') {
          if (!formStateTemp1.doj.value) {
            isFormError = true;
            formStateTemp1.doj.isError = true;
            formStateTemp1.doj.message = 'DOJ cannot be kept blank. Select a valid Date of Registration on JANANI.';
          }
          else {
            formStateTemp1.doj.isError = false;
          }
        }
        else if (item === 'hpr_id' && formStateTemp1.hpr_id.value) {
          if ( !/^[0-9]+$/.test(formStateTemp1.hpr_id.value)) {
            isFormError = true;
            formStateTemp1.hpr_id.isError = true;
            formStateTemp1.hpr_id.message = 'Entered hpr id is invalid. Alphabets & Special characters are not allowed.';
            dispatch(updateForm("hprNullCheck",false))
            dispatch(updateForm("hprNumberCheck",false));
            dispatch(updateForm("isOkButtonClicked",false))
            dispatch(updateForm("ishprEntered",false));
            
          }
          else {
            formStateTemp1.hpr_id.isError = false;
          }
        }
        if((!isFormError && !formStateTemp1.hpr_id.value && (formState1.user_type.value==='Facility Level User' || formState1.user_type.value==='Field Level User') && !isOkButtonClicked && !hprNullCheck)){
          if(formState1.designation.value!== userDesignationConstant.h_a_dh_sdh && formState1.designation.value!==userDesignationConstant.h_a_other_central_government_hospitals &&
              formState1.designation.value!==userDesignationConstant.medical_director && formState1.designation.value!==userDesignationConstant.medical_suprintendent
            ) {
              setAlertModalOpen(true)
              isFormError = true;
              dispatch(updateForm("hprNullCheck",true))
              dispatch(updateForm("hprNumberCheck",false));
              dispatch(updateForm("ishprEntered",false));
          }
        }
        if((!ishprEntered && formStateTemp1.hpr_id.value && formStateTemp1.hpr_id.value && /^[0-9]+$/.test(formStateTemp1.hpr_id.value) && !hprNumberCheck)){
          setAlertModalOpen(true)
          isFormError = true;
          dispatch(updateForm("hprNumberCheck",true));
          dispatch(updateForm("hprNullCheck",false))
          dispatch(updateForm("clearHpr",false));
          dispatch(updateForm("isOkButtonClicked",false))
        }
        if( ((formState1.user_type.value==='Facility Level User' || formState1.user_type.value==='Field Level User') && formStateTemp1.hpr_id.value && /^[0-9]+$/.test(formStateTemp1.hpr_id.value) && isNotVerified)){
          setAlertModalOpen(true)
          isFormError = true;
        }

      })
      await Promise.all(validationPromises)
      // tigger validation  // tempDate haserror
      setFormState1(formStateTemp1);
      errors[0] = isFormError;
    }
    if (activeIndex === 1) {
      
      //if(ruralUrban==='Rural'){
       const tempChange2 = {
          ...roleFormState
        }
        const tempFormData2 = {
          ...roleFormData
        }
 
      
      let isFormError = false;
      Object.keys(tempChange2).map((item) => {
        if (item === 'role_name' && tempFormData2[item]['#required'] === true) {
          if (!tempChange2.role_name.value || tempChange2.role_name.value.length <= 0) {
            tempChange2.role_name.isError = true;
            tempChange2.role_name.message = 'Role cannot be kept blank. Select user role(s)  from dropdown.';
            isFormError = true;
          }
          else {
            tempChange2.role_name.isError = false;
          }

        }
        else if(item==='state' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false){
          if(!tempChange2.state.value){
            isFormError = true;
            tempChange2.state.isError=true;
            tempChange2.state.message='State cannot be kept blank. Select user state from dropdown.';

          }
          else{
            tempChange2.state.isError=false;
          }
        }
        else  if(item==='zone_div_circle' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false){
          if(tempChange2.zone_div_circle.value?.length === 0 || tempChange2.zone_div_circle.value === undefined){
            isFormError = true;
            tempChange2.zone_div_circle.isError=true;
            tempChange2.zone_div_circle.message='Zone/Division/Circle cannot be kept blank. Select user Zone/Division/Circle from dropdown.';
          }
          else{
            tempChange2.district.isError=false;
          }
        }
        else  if(item==='district' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false){
          if(!tempChange2.district.value){
            isFormError = true;
            tempChange2.district.isError=true;
            tempChange2.district.message='District cannot be kept blank. Select user District from dropdown.';
          }
          else{
            tempChange2.district.isError=false;
          }
        }
        else  if(item==='sub_district' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false){
          if(!tempChange2.sub_district.value){
            isFormError = true;
            tempChange2.sub_district.isError=true;
            tempChange2.sub_district.message='Sub District cannot be kept blank. Select user Sub District from dropdown.';
          }
          else{
            tempChange2.sub_district.isError=false;
          }
        }
        else  if(item==='health_block' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false){
          if(!tempChange2.health_block.value){
            isFormError = true;
            tempChange2.health_block.isError=true;
            tempChange2.health_block.message='Health Block cannot be kept blank. Select user Health Block from dropdown.';
          }
          else{
            tempChange2.health_block.isError=false;
          }
        }
        else  if(item==='sub_division' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false){
          if(!tempChange2.sub_division.value){
            isFormError = true;
            tempChange2.sub_division.isError=true;
            tempChange2.sub_division.message='Sub Division cannot be kept blank. Select user Sub Division from dropdown.';
          }
          else{
            tempChange2.sub_division.isError=false;
          }
        }
        else  if(item==='rural_urban' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false){
          if(!tempChange2.rural_urban.value){
            isFormError = true;
            tempChange2.rural_urban.isError=true;
            tempChange2.rural_urban.message='Select Rural or Urban from the dropdown.';
          }
          else{
            tempChange2.rural_urban.isError=false;
          }
        }
        else  if(item==='ulb' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false){
          if(!tempChange2.ulb.value){
            isFormError = true;
            tempChange2.ulb.isError=true;
            tempChange2.ulb.message='Select ULB from the dropdown.';
          }
          else{
            tempChange2.ulb.isError=false;
          }
        }
        else  if(item==='block' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false){
          if(!tempChange2.block.value){
            isFormError = true;
            tempChange2.block.isError=true;
            tempChange2.block.message='Select Block from the dropdown.';
          }
          else{
            tempChange2.block.isError=false;
          }
        }
        else  if(item==='ward' && tempChange2.rural_urban.value === 'Urban' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false){
          if(!tempChange2.ward.value){
            isFormError = true;
            tempChange2.ward.isError=true;
            tempChange2.ward.message='Select Ward from the dropdown.';
          }
          else{
            tempChange2.ward.isError=false;
          }
        }
        else  if(item==='village' && tempChange2.rural_urban.value === 'Rural' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false && tempFormData2[item]['#isVisible']){
          if(!tempChange2.village.value){
            isFormError = true;
            tempChange2.village.isError=true;
            tempChange2.village.message='Select Village from the dropdown.';
          }
          else{
            tempChange2.village.isError=false;
          }
        }
        else  if(item==='gram_panchayat' && tempChange2.rural_urban.value === 'Rural' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false && tempFormData2[item]['#isVisible']){
          if(!tempChange2.gram_panchayat.value){
            isFormError = true;
            tempChange2.gram_panchayat.isError=true;
            tempChange2.gram_panchayat.message='Select Gram Panchayat / ADC Village from the dropdown.';
          }
          else{
            tempChange2.gram_panchayat.isError=false;
          }
        }

       
      })
      errors[1] = isFormError;
        setRoleFormState(tempChange2)
    }
    if (activeIndex === 2) {
      let tempChange3;
      let facilityTabDetailsData;
       if(formState1.user_type.value==='Facility Level User'){
        tempChange3 = {
          ...formStateForFacility
        }
        facilityTabDetailsData={
          ...facilityFormData
        }
      }
      else{
         tempChange3 = {
          ...formStateForField
        }
        facilityTabDetailsData={
          ...fieldFormData
        }
      }
     
      
      let isFormError = false;
      Object.keys(tempChange3).map((item) => {
        if (item === 'hprId') {
          if (!tempChange3.hprId.value) {
            tempChange3.hprId.isError = true;
            tempChange3.hprId.message = 'HFR ID is required. Enter a valid HFR Identification.';
            isFormError = true;
          }
          else {
            tempChange3.hprId.isError = false;
          }

        }
        else if (item === 'abhaId') {
          if (!tempChange3.abhaId.value) {
            isFormError = true;
            tempChange3.abhaId.isError = true;
            tempChange3.abhaId.message = 'ABHA Number is required. Enter a valid ABHA.';
          }
          else {
            tempChange3.abhaId.isError = false;
          }
        }
        else if(item === 'hfr_id'){
          if (!tempChange3.hfr_id.value) {
            isFormError = true;
            tempChange3.hfr_id.isError = true;
            tempChange3.hfr_id.message = 'HFR ID is required. Enter a valid HFR Id';
          }
          else {
            tempChange3.hfr_id.isError = false;
          }
        }
       
        else if (item === 'health_facility_type') {
          if (!tempChange3.health_facility_type.value) {
            isFormError = true;
            tempChange3.health_facility_type.isError = true;
            tempChange3.health_facility_type.message = 'Health Facility Type cannot be kept blank. Select an applicable option from Dropdown.';
          }
          else {
            tempChange3.health_facility_type.isError = false;
          }
        }
        else if (item === 'health_facility_name') {
          if (!tempChange3.health_facility_name.value) {
            isFormError = true;
            tempChange3.health_facility_name.isError = true;
            tempChange3.health_facility_name.message = 'Health Facility Name cannot be kept blank. Select an applicable option from Dropdown.';
          }
          else {
            tempChange3.health_facility_name.isError = false;
          }
        }
        else if (item === 'ward' && !tempChange3.ward.value.length && facilityTabDetailsData[item]['#required'] === true && facilityTabDetailsData[item]['#isDisabled'] === false) {
          if (tempChange3.ward.value.length === 0) {
            isFormError = true;
            tempChange3.ward.isError = true;
            tempChange3.ward.message = 'Select Ward from the dropdown.';
          }
          else {
            tempChange3.ward.isError = false;
          }
        }
        else if (item === 'village' && !tempChange3.village.value.length && facilityTabDetailsData[item]['#required'] === true && facilityTabDetailsData[item]['#isVisible'] && facilityTabDetailsData[item]['#isDisabled'] === false) {
          if (tempChange3.village.value.length === 0) {
            isFormError = true;
            tempChange3.village.isError = true;
            tempChange3.village.message = 'Select Village from the dropdown.';
          }
          else {
            tempChange3.village.isError = false;
          }
        }
        else if (item === 'gram_panchayat' && !tempChange3.gram_panchayat.value.length && facilityTabDetailsData[item]['#required'] === true && facilityTabDetailsData[item]['#isVisible'] && facilityTabDetailsData[item]['#isDisabled'] === false) {
          if (tempChange3.gram_panchayat.value.length === 0) {
            isFormError = true;
            tempChange3.gram_panchayat.isError = true;
            tempChange3.gram_panchayat.message = 'Select Gram Panchayat / ADC Village from the dropdown.';
          }
          else {
            tempChange3.gram_panchayat.isError = false;
          }
        }
       
      })
      errors[2] = isFormError;
      if(formState1.user_type.value==='Facility Level User'){
        setFormStateForFacility(tempChange3);
      }
      else{
        setFormStateForField(tempChange3);
      
    }

    } 
  setErrors(errors);
}     catch(error:any){
  errorLogger(error?.response?.data||error?.response||error)
}
};

  const finishHandler = async () => {
    let isAbha=false;
    let isFacilityFieldLevelUser=false;
    let isFieldLevelUser=false;
      if(formState1.user_type.value==='Field Level User'){
        isAbha=true;
        isFieldLevelUser=true;
      }
      if(formState1.user_type.value==='Facility Level User'){
        isFacilityFieldLevelUser=true;
      } else if(formState1.user_type.value==='Field Level User'){
        isFacilityFieldLevelUser=true;
      }
      else{
        isFacilityFieldLevelUser=false;
      }
      const consentNeededForABha=isAbha? (isVerified?hfrAbhaId:''):'';
      const consentNeededForHPR=isAbha?'': (isVerified?hfrAbhaId:'');
      const consentNeeded=consentNeededForABha?true:consentNeededForHPR?true:false;
      let payload:any ={
        fName: formState1.fName?.value,
        lName: formState1.lName?.value,
        email: formState1.email?.value ?? '',
        mob: formState1.mob?.value,
        userDesignationId: formState1.designation?.id,
        doj: new Date(dayjs(formState1.doj?.value).format('YYYY-MM-DD')).toISOString().split('T')[0],
        userTypeId: formState1.user_type?.id,
        mfa: roleFormState.mfa?.value,
        effectiveFromDt:new Date(dayjs(formState1.doj?.value).format('YYYY-MM-DD')).toISOString().split('T')[0],
        volunteerForPmsma: formStateForFacility?.volunteerForPmsma?.value,
        userStatus: formState1.user_status?.value ? 'Active': 'Inactive',
        reportUserWithLineListingData: roleFormState.reportUserWithLineListingData?.value,
        offlineModeAccess: roleFormState.offlineModeAccess?.value,
        stId: roleFormState.state?.id ?? '',
        stCode:  roleFormState.state?.code ? Number(roleFormState.state?.code) : null,   
        roleId: (roleFormState.role_name?.id === '' || roleFormState.role_name?.id === undefined || roleFormState.role_name?.id === null) ? [] : roleFormState.role_name?.id,
        healthProviderId:isFieldLevelUser?formStateForField.health_provider_tagged.id : [],
        mobiliserId:!isFieldLevelUser? formStateForFacility.mobiliser_tagged.id : [],
        villageIds:ruralUrban==='Rural' && !isGrampanchayat?(isFacilityLevelUser?formStateForFacility.village?.id:formStateForField.village?.id):[] ,
        villageCodes:ruralUrban==='Rural' && !isGrampanchayat?(isFacilityLevelUser?formStateForFacility.village?.code:formStateForField.village?.code) : [],
        gramPanchayatIds:ruralUrban==='Rural' && isGrampanchayat?(isFacilityLevelUser?formStateForFacility.gram_panchayat?.id:formStateForField.gram_panchayat?.id):[] ,
        gramPanchayatCodes:ruralUrban==='Rural' && isGrampanchayat?(isFacilityLevelUser?formStateForFacility.gram_panchayat?.code:formStateForField.gram_panchayat?.code) : [],
        wardIds:ruralUrban==='Urban'?(isFacilityLevelUser?formStateForFacility.ward?.id:formStateForField.ward?.id):[],
        wardCodes:ruralUrban==='Urban'?(isFacilityLevelUser?formStateForFacility.ward?.code:formStateForField.ward?.code):[],                   //
        mName: formState1?.middle_name?.value ?? '',               // ????? no middle name
        alternateMob: formState1.a_mob?.value ?? '',
        abhaId:isAbha? (isVerified?hfrAbhaId:''):'',
        hprId:isAbha?'': (isVerified?hfrAbhaId:''),
        zoneDivCircleId: (roleFormState.zone_div_circle?.id === '' || roleFormState.zone_div_circle?.id === undefined || roleFormState.zone_div_circle?.id === null) ? [] : roleFormState.zone_div_circle?.id,
        compositeRoleId: (roleFormState.role_name?.compositeRoleId === '' || roleFormState.role_name?.compositeRoleId === undefined || roleFormState.role_name?.compositeRoleId === null) ? [] : roleFormState.role_name?.compositeRoleId,
        distId: roleFormState.district?.id ?? '',   
        distCode: roleFormState.district?.code ? Number(roleFormState.district?.code) : null,   
        subDistId:roleFormState.sub_district?.id ?? '',
        ulbId: roleFormState.ulb?.id ?? '',
        blockId: roleFormState.block?.id ?? '',
        healthBlockId: roleFormState.health_block?.id ?? '',
        subDivisionId: roleFormState.sub_division?.id ?? '',
        pcId: '',
        lacId:'',
        wardId: roleFormState.ward?.id ?? '',
        gramPanchayatId: isGrampanchayat ? roleFormState.gram_panchayat?.id : '',
        villageId: !isGrampanchayat ? roleFormState.village?.id : '',
        facilityId: isFieldLevelUser?formStateForField?.health_facility_name?.id: formStateForFacility?.health_facility_name?.id ?? '',   ///???? no id 
        //facilityId: "bf426274-d06a-40fb-aa3c-1fe8d3c3bcf1",   ///???? no id 
        urbanRuralId: roleFormState.rural_urban?.id ?? '',
        urbanRuralValue: roleFormState.rural_urban?.value ?? '',
        isFacilityLevel:isFacilityFieldLevelUser,
        isGrampanchayat:isGrampanchayat,
        parentUserId: '',
        parentUsertypeId: '',
        parentRoleId:'',
        imageData:'',
        description:'',
        url:'',
        consent_template_details:consentNeeded? consentDetails?.length === 0 ? null : consentDetails.map((item:any) => ({"consent_template_id":item.consent_template_id})):null,
        processType: 'reg_through_other_user',
        verificationProcessId: verificationProcessId || '',      
      }      
try {
  if (Files) {
    const response = await axios.post(
      `${endpoints.upload}`,
      Files,
      Auth.loggedInWithMultipart()
    );
    const imageToken = response?.data?.data?.imageToken || null;

    payload = {
      ...payload,
      imageToken,
      url: null,
      description: 'Image for user',
    };
  }
  setIsLoading(true)
  const response = await axios.post(`${endpoints.insertUser}`, payload, Auth.loggedInWithJSON());
  if(response.status !== 200)
  {
    throw new Error("Error in Creating User");
  }
  infoLogger(`User has been Created Successfully with the mobile number: ${formState1.mob?.value}, status: ${formState1.user_status?.value}, HPR Id: ${payload?.hprId}, ABHA Id: ${payload?.abhaId}.`,"User Management - Create User");
  dispatch(resetForm());
  navigate(`/user-management`);
  toast.success("Records have been successfully created", {
  position: "top-center"
  }); 
}catch(error:any) {
  const errorMessage=error?.response?.data?.messages?.[0]?.stackTraces ||
    error?.response?.data?.messages?.[0]?.messageDetails||
    error?.response?.data?.messages||
    error?.response?.data||
    error?.response||
    error?.message||
    error;
  toast.error(
    `Error while inserting the User: ${errorMessage}`, {
    position: "top-right"
    });
    errorLogger(`Error while inserting the User  ${formState1.mob?.value} of type ${formState1.user_type?.value}: ${errorMessage}`);
} finally {
  setIsLoading(false)
}
 

  };

  useEffect(() => {
    setIsFormValidated(false);
  }, [activeIndex]);

  useEffect(() => {
    if (!errors[activeIndex] && isFormValidated) {
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = true;
      setFormCompleted(newFormCompleted);
      const perc = (activeIndex + 1) * navs;
      setSelectedPerc(perc);
    }
    if (errors[activeIndex] && formCompleted[activeIndex]) {
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = false;
      setFormCompleted(newFormCompleted);
    }
  }, [errors]);

  const breadcrumbItemName=[
    { value: page, label: 'User Management' },
    { value: page, label: 'Create User' },
  ];

  const onHandleBackArrowButton=()=>{
    navigate(`/user-management`);
    dispatch(resetForm());
  };

  const handleNavClick = (index: number): void => {
    if (formCompleted[index]) {
      setActiveIndex(index);
    }
  };

  const handlePrevious = (): void => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = false;
      newFormCompleted[activeIndex - 1] = false;
      setFormCompleted(newFormCompleted);
      const perc = (activeIndex - 1) * navs;
      setSelectedPerc(perc);
    }
  };

  const handleSubmit = (): void => {
    handleSave(activeIndex);
    setIsFormValidated(true);
  };

  const handleNext = (): void => {
    if (activeIndex < navItemsModal.length - 1) {
      setActiveIndex(activeIndex + 1);
    } else if (activeIndex === navItemsModal.length - 1) {
      setSelectedPerc(selectPerc + navs);
    }
  };

  const CloseFacility=()=>{
    setCloseModal(true);
  }

  const closeCreateModal=(value:boolean)=>{
    if(value){
      setCloseModal(false);
      dispatch(resetForm());
      navigate(`/user-management`);
    }
    else{
      setCloseModal(false);
    }
  }

  return (
    <>
    <Loading isLoading={isLoading} />
     

          <CreateCommonComponent 
            breadcrumbItemName={breadcrumbItemName} 
            onHandleBackArrowButton={onHandleBackArrowButton}
            navItemsModal={navItemsModal}
            activeIndex={activeIndex}
            handleNavClick={handleNavClick}
            formCompleted={formCompleted}
            headerName={"Create a new user"}
            progressBarPerc={selectPerc}
            contents={contents}
            handlePrevious={handlePrevious}
            handleSubmit={handleSubmit}
            finishHandler={finishHandler}
            handleNext={handleNext}
            handleCancel={CloseFacility}
            closeCreateModal={closeCreateModal}
            closeModal={closeModal}
          />
      <CommonModal
      show={alertModalOpen}
      handleClose={()=>{}}
      conditionalClass="modal_component dynamic_form_field"
      showCustomHeader={true}
      title=""
      size="md"
      footer={
        <>
          <ButtonModal
            onClick={handleOK}
            id="cancel"
            buttonName={'OK'}
            colorType={'secondary'}
          />
        </>
      }
    >
      <div className='hrp-warning-modal'>
        <div className='icon-class'><RedInfoIcon /></div>
        <div className='warning-text'>
          Please note that you are proceeding without verifying {(formState1.user_type.value === 'Field Level User' || (formState1.user_type.value === 'Facility Level User' && formState1.designation?.value === 'MPW/MPHW')) ? 'ABHA ID' : 'HPR ID'}. In that case, saved user will be inactive and {(formState1.user_type.value === 'Field Level User' || (formState1.user_type.value === 'Facility Level User' && formState1.designation?.value === 'MPW/MPHW')) ? 'ABHA ID' : 'HPR ID'} would not be saved.
        </div>
      </div>
    </CommonModal>
    </>
  );

};

export default CreateNewUser;
